"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6922],{

/***/ 75711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pt": function() { return /* reexport */ asset_config/* asset */.p; },
  "gX": function() { return /* reexport */ buttonLink; },
  "Xw": function() { return /* reexport */ circle; },
  "$J": function() { return /* reexport */ clickableImageGallery; },
  "Gx": function() { return /* reexport */ collaborationWith; },
  "MV": function() { return /* reexport */ comparisonTable; },
  "HK": function() { return /* reexport */ coupon; },
  "dt": function() { return /* reexport */ directoryListData; },
  "RX": function() { return /* reexport */ exitPopupConfig; },
  "V": function() { return /* reexport */ extendTrialCookie; },
  "Mv": function() { return /* reexport */ footer; },
  "gS": function() { return /* reexport */ mobileImageWidthRatio; },
  "IO": function() { return /* reexport */ one_pager/* assetPart */.Bw; },
  "OX": function() { return /* reexport */ one_pager/* fullHeightVideoPart */.et; },
  "HJ": function() { return /* reexport */ one_pager/* imageWithBackgroundPart */.C6; },
  "y6": function() { return /* reexport */ one_pager/* mobileAssetType */.TA; },
  "hh": function() { return /* reexport */ one_pager/* mobileType */.BJ; },
  "Lk": function() { return /* reexport */ one_pager/* textPart */.iQ; },
  "An": function() { return /* reexport */ paragraph; },
  "ex": function() { return /* reexport */ paragraphAndAssetColumns; },
  "TM": function() { return /* reexport */ paragraphWithBottomLink; },
  "NH": function() { return /* reexport */ popupVideo; },
  "PJ": function() { return /* reexport */ showSegment; },
  "L": function() { return /* reexport */ signup_form/* signupForm */.L; },
  "x9": function() { return /* reexport */ signup_form/* signupFormWithDecorations */.x; },
  "nc": function() { return /* reexport */ socialButtons; },
  "A0": function() { return /* reexport */ stars; },
  "lI": function() { return /* reexport */ topbar; }
});

// UNUSED EXPORTS: imageGalleryWithParagraph, topBanner

;// CONCATENATED MODULE: ./components/templates-generator/config/components/comparison-table/comparison-table.js
var comparisonTable = {
    type: "nested",
    label: "Comparison Table",
    fields: {
        title: {
            type: "text",
            label: "Title"
        },
        subtitle: {
            type: "text",
            label: "Subtitle"
        },
        competitorLogo: {
            type: "nested",
            label: "Competitor",
            fields: {
                src: {
                    type: "gallery",
                    defaultImagesKeys: [
                        "static/img/templates/comparison-table/competitors/"
                    ],
                    label: "Competitor Logo",
                    options: [
                        {
                            value: "/static/img/competitors/trello.png",
                            text: "Trello"
                        },
                        {
                            value: "/static/img/competitors/asana.png",
                            text: "Asana"
                        },
                        {
                            value: "/static/img/competitors/atlassian.png",
                            text: "Atlassian"
                        },
                        {
                            value: "/static/img/competitors/basecamp.png",
                            text: "Basecamp"
                        },
                        {
                            value: "/static/img/competitors/confluence.png",
                            text: "Confluence"
                        },
                        {
                            value: "/static/img/competitors/jira.png",
                            text: "Jira"
                        },
                        {
                            value: "/static/img/competitors/sharepoint.png",
                            text: "SharePoint"
                        },
                        {
                            value: "/static/img/competitors/slack.png",
                            text: "Slack"
                        },
                        {
                            value: "/static/img/competitors/todoist.png",
                            text: "Todoist"
                        },
                        {
                            value: "/static/img/competitors/smartsheet.png",
                            text: "Smartsheet"
                        },
                        {
                            value: "/static/img/competitors/wrike.png",
                            text: "Wrike"
                        },
                        {
                            value: "/static/img/competitors/wunderlist.png",
                            text: "Wunderlist"
                        },
                        {
                            value: "/static/img/competitors/yammer.png",
                            text: "Yammer"
                        }
                    ]
                },
                height: {
                    type: "text",
                    label: "Image height % (optional, 50-100)"
                }
            }
        },
        features: {
            type: "segments",
            label: "Features",
            types: {
                feature: {
                    type: "nested",
                    fields: {
                        title: {
                            type: "combo",
                            label: "Feature Title",
                            options: [
                                "In app communication",
                                "Gantt chart",
                                "Time management",
                                "Files management",
                                "Supports agile",
                                "Budget management",
                                "Export dashboards",
                                "Mobile app",
                                "Use templates",
                                "24/7 support",
                                "Subtasks",
                                "Shareable dashboards",
                                "Deadline management",
                                "Time tracking",
                                "Email notifications",
                                "Fun giphys",
                                "Client management ",
                                "Full API",
                                "Integrations",
                                "Import from Excel"
                            ],
                            otherOption: {
                                text: "Put your own feature...",
                                inputPlaceholder: "Put your own feature..."
                            }
                        },
                        monday: {
                            type: "combo",
                            label: "Monday",
                            options: [
                                {
                                    value: "true",
                                    text: "Yes"
                                },
                                {
                                    value: "false",
                                    text: "No"
                                }
                            ],
                            otherOption: {
                                text: "Put your own text...",
                                inputPlaceholder: "Put your own URL..."
                            }
                        },
                        competitor: {
                            type: "combo",
                            label: "Competitor",
                            options: [
                                {
                                    value: "true",
                                    text: "Yes"
                                },
                                {
                                    value: "false",
                                    text: "No"
                                }
                            ],
                            otherOption: {
                                text: "Put your own text...",
                                inputPlaceholder: "Put your own text..."
                            }
                        },
                        bigTexts: {
                            type: "boolean",
                            label: "Big Texts"
                        }
                    }
                }
            }
        }
    },
    defaultData: {
        comparisonTable: {
            title: "May the best product win!",
            subtitle: "monday.com is powerful enough to track everything your team is working on—so you can get results.",
            features: []
        }
    }
};

// EXTERNAL MODULE: ./components/templates-generator/config/components/signup-form/signup-form.js
var signup_form = __webpack_require__(60781);
;// CONCATENATED MODULE: ./components/templates-generator/config/components/collaboration-with/collaboration-with.js
var collaborationWith = {
    type: "nested",
    label: "Collboration Config",
    fields: {
        show: {
            type: "boolean",
            label: "Show"
        },
        color: {
            type: "colorPicker",
            label: "Text Color",
            possibleColors: [
                "black",
                "white"
            ]
        },
        text: {
            type: "text",
            label: "Text"
        },
        imageUrl: {
            type: "gallery",
            label: "Select a logo",
            defaultImagesKeys: [
                "static/img/templates/collaboration-with/podcast-logos/"
            ],
            options: [
                {
                    value: "/static/img/podcast-logos/codepen.png",
                    text: "Codepen"
                }
            ]
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/coupon/coupon.js
var coupon = {
    type: "nested",
    label: "Coupon",
    fields: {
        code: {
            type: "text",
            label: "Code"
        },
        daysToExpire: {
            type: "text",
            label: "Expire Days"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/extend-trial-cookie/extend-trial-cookie.js
var extendTrialCookie = {
    type: "nested",
    label: "Extend Trial Cookie, (Get token here: https://forms.monday.com/forms/4555757001e20a941a5d413f8953e80e?r=use1)",
    fields: {
        token: {
            type: "text",
            label: "Dev Token For Extending"
        },
        daysToExpire: {
            type: "text",
            label: "Expire Days From Visit"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/top-banner/top-banner.js
var topBanner = {
    type: "nested",
    label: "Top Banner",
    fields: {
        show: {
            type: "boolean",
            label: "Show top banner"
        },
        topBannerText: {
            type: "text",
            label: "Top Banner Text"
        },
        topBannerUrl: {
            type: "text",
            label: "Read More Url (optional)"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/social-buttons/social-buttons.js
var socialButtons = {
    type: "nested",
    label: "Social Buttons",
    fields: {
        show: {
            type: "boolean",
            label: "Show social buttons"
        },
        color: {
            type: "colorPicker",
            label: "Text Color",
            possibleColors: [
                "black",
                "white"
            ]
        },
        blogStyle: {
            type: "boolean",
            label: "Blog style"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/popup-video/popup-video.js
var popupVideo = {
    type: "nested",
    label: "Popup Video",
    fields: {
        show: {
            type: "boolean",
            label: "Show"
        },
        videoId: {
            type: "text",
            label: "Youtube Video ID"
        },
        playButtonText: {
            type: "text",
            label: "Play Button Text"
        },
        footerText: {
            type: "text",
            label: "Popup Footer Text"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/footer/footer-config.js
var footer = {
    type: "nested",
    label: "Footer Config",
    fields: {
        preventFooter: {
            type: "boolean",
            label: "Prevent Footer"
        },
        footerBg: {
            type: "colorPicker",
            label: "Footer Background",
            possibleColors: [
                "snow"
            ]
        },
        footerTextColor: {
            type: "colorPicker",
            label: "Footer Text Color",
            possibleColors: [
                "black"
            ]
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/topbar/topbar-config.js
var topbar = {
    type: "nested",
    label: "Topbar Config",
    fields: {
        showMenu: {
            type: "boolean",
            label: "Show Menu"
        },
        shortHeader: {
            type: "boolean",
            label: "Short Header"
        },
        maxWidth: {
            type: "text",
            label: "Max Width"
        }
    }
};

// EXTERNAL MODULE: ./components/templates-generator/config/components/one-pager/one-pager.js
var one_pager = __webpack_require__(75203);
;// CONCATENATED MODULE: ./components/templates-generator/config/components/directory-list-data/directory-list-data.js
var directoryListData = {
    type: "segments",
    label: "Pages",
    types: {
        link: {
            type: "nested",
            label: "Link",
            fields: {
                image: {
                    type: "gallery",
                    label: "Select an image",
                    defaultImagesKeys: [
                        "static/img/templates/directory-list-data/thumbnails/"
                    ]
                },
                firstTitle: {
                    type: "nested",
                    label: "First Title Line",
                    fields: {
                        text: {
                            type: "text",
                            label: "Text"
                        },
                        decorator: {
                            type: "text",
                            label: "Text decorator"
                        }
                    }
                },
                secondTitle: {
                    type: "nested",
                    label: "Second Title Line",
                    fields: {
                        text: {
                            type: "text",
                            label: "Text"
                        },
                        decorator: {
                            type: "text",
                            label: "Text decorator"
                        }
                    }
                },
                subtitle: {
                    type: "text",
                    label: "Subtitle (Appears on hover)"
                },
                link: {
                    type: "text",
                    label: "Thumbnail Link (Appears on hover)"
                },
                buttomLink: {
                    type: "nested",
                    label: "Buttom Link (Appears on hover)",
                    fields: {
                        show: {
                            type: "boolean",
                            label: "Should Show link"
                        },
                        text: {
                            type: "text",
                            label: "Link text"
                        },
                        url: {
                            type: "text",
                            label: "URL / Path"
                        },
                        color: {
                            type: "colorPicker",
                            label: "Text Color",
                            possibleColors: [
                                "brand-blue",
                                "black"
                            ]
                        }
                    }
                },
                hoverDecorator: {
                    type: "nested",
                    label: "Hover Decorator (Appears on hover)",
                    fields: {
                        show: {
                            type: "boolean",
                            label: "Should Show"
                        },
                        text: {
                            type: "text",
                            label: "Text"
                        }
                    }
                }
            }
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/exit-popup/exit-popup.js
var exitPopupConfig = {
    type: "nested",
    label: "Exit Popup",
    fields: {
        title: {
            type: "text",
            label: "Title"
        },
        subtitle: {
            type: "text",
            label: "Subtitle"
        },
        signupConfig: {
            type: "nested",
            label: "Signup Config",
            fields: {
                headerText: {
                    type: "text",
                    label: "Header Text"
                },
                buttonText: {
                    type: "text",
                    label: "Button Text"
                },
                inputPlaceholder: {
                    type: "text",
                    label: "Input Placeholder"
                },
                footerText: {
                    type: "text",
                    label: "Footer Text"
                }
            }
        }
    }
};

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./components/templates-generator/config/components/paragraph/paragraph-config.js


var paragraph = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Paragraph",
    fields: {
        textDirection: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Text Direction",
            options: [
                {
                    value: "left",
                    text: "Left"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "right",
                    text: "Right"
                }
            ]
        },
        topic: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Topic",
            fields: {
                text: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                }
            }
        },
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title"
        },
        titleFontSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title Font Size"
        },
        body: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_TEXTS,
            label: "Body"
        },
        showSignup: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Signup"
        },
        signupForm: signup_form/* signupForm */.L
    }
};
var paragraphWithBottomLinkConfig = paragraph;
paragraphWithBottomLinkConfig.fields["bottomLink"] = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Bottom Link",
    fields: {
        text: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text"
        },
        href: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Url"
        }
    }
};
var paragraphWithBottomLink = paragraphWithBottomLinkConfig;

;// CONCATENATED MODULE: ./components/templates-generator/config/components/image-gallery-with-paragraph/image-gallery-with-paragraph-config.js


var imageGalleryWithParagraph = {
    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
    label: "Image With Paragraph",
    maxLimit: 10,
    nestedConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        fields: {
            url: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                label: "Image",
                defaultImagesKeys: []
            },
            paragraph: paragraphWithBottomLink
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/image-gallery-with-text/image-gallery-with-text-config.js

var clickableImageGallery = {
    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
    label: "Image With Text",
    maxLimit: 10,
    nestedConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        fields: {
            url: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                label: "Image",
                defaultImagesKeys: []
            },
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Link To"
            }
        }
    }
};

// EXTERNAL MODULE: ./constants/video-types.js
var video_types = __webpack_require__(39832);
;// CONCATENATED MODULE: ./components/templates-generator/config/components/paragraph-and-asset-columns/paragraph-and-asset-columns-config.js


var paragraphAndAssetColumns = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Text and Asset",
    fields: {
        content: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Content",
            fields: {
                topic: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Topic",
                    fields: {
                        text: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Text"
                        },
                        color: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Color"
                        }
                    }
                },
                image: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Title image",
                    fields: {
                        src: {
                            type: template_field_type.FIELD_TYPES.GALLERY,
                            defaultImagesKeys: [
                                "static/img/templates/long-template/boards/"
                            ],
                            label: "Select an Image"
                        },
                        alt: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Image description (alt)"
                        }
                    }
                },
                title: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title"
                },
                body: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_TEXTS,
                    label: "Content",
                    textArea: true,
                    maxLineChars: 574
                },
                bottomLink: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Bottom Link",
                    fields: {
                        text: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Text"
                        },
                        href: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Url"
                        }
                    }
                }
            }
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: {
                shadow: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Shadow Frame"
                },
                side: {
                    type: template_field_type.FIELD_TYPES.COMBO,
                    label: "Asset Location",
                    options: [
                        "left",
                        "right"
                    ]
                },
                image: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Image",
                    fields: {
                        src: {
                            type: template_field_type.FIELD_TYPES.GALLERY,
                            defaultImagesKeys: [
                                "static/img/templates/long-template/boards/"
                            ],
                            label: "Select an Image"
                        },
                        alt: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Image description (alt)"
                        }
                    }
                },
                video: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Add a Video",
                    fields: {
                        src: {
                            type: template_field_type.FIELD_TYPES.VIDEO_PICKER,
                            label: "Video",
                            videoType: video_types/* PARAGRAPH_AND_ASSET_VIDEOS */.rB
                        },
                        loop: {
                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                            label: "Loop",
                            options: [
                                "Yes",
                                "No"
                            ]
                        },
                        playWhenVisible: {
                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                            label: "Play Only When Visible",
                            options: [
                                "Yes",
                                "No"
                            ]
                        }
                    }
                }
            }
        }
    }
};

// EXTERNAL MODULE: ./components/templates-generator/config/components/asset/asset-config.js
var asset_config = __webpack_require__(81338);
;// CONCATENATED MODULE: ./components/templates-generator/config/components/circle/circle-config.js

var circle = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Circle",
    fields: {
        position: {
            type: "text",
            label: "position"
        },
        width: {
            type: "text",
            label: "Width"
        },
        height: {
            type: "text",
            label: "Height"
        },
        background: {
            type: "text",
            label: "background"
        },
        top: {
            type: "text",
            label: "top"
        },
        left: {
            type: "text",
            label: "left"
        },
        zIndex: {
            type: "text",
            label: "z index"
        },
        borderRadius: {
            type: "text",
            label: "border radius"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/show-segment/show-segment-config.js

var showSegment = {
    type: template_field_type.FIELD_TYPES.COMBO,
    label: "Show Segment",
    options: [
        {
            value: "all",
            text: "All"
        },
        {
            value: "desktop",
            text: "Desktop Only"
        },
        {
            value: "mobile",
            text: "Mobile Only"
        }
    ]
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/mobile-image/mobile-image-ratio-config.js

var mobileImageWidthRatio = {
    type: template_field_type.FIELD_TYPES.COMBO,
    label: "Mobile Image width Ratio",
    options: [
        "0.1",
        "0.2",
        "0.3",
        "0.4",
        "0.5",
        {
            value: "0.6",
            text: "0.6 (Default)"
        },
        "0.7",
        "0.8",
        "0.9",
        "1"
    ]
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/button/button-config.js

var buttonLink = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Button Link",
    fields: {
        color: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Color"
        },
        textColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Text Color"
        },
        fontSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Font Size"
        },
        text: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text"
        },
        shouldForwardUrlParams: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Should forward url params"
        },
        href: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "URL"
        },
        placement: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "BigBrain Placement"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/stars/stars-config.js

var stars = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Stars",
    fields: {
        paddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Padding top"
        },
        showStars: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show stars"
        },
        numberOfSelectedStars: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Number of selected stars"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/components/index.js

























/***/ }),

/***/ 75203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ mobileType; },
/* harmony export */   "Bw": function() { return /* binding */ assetPart; },
/* harmony export */   "C6": function() { return /* binding */ imageWithBackgroundPart; },
/* harmony export */   "TA": function() { return /* binding */ mobileAssetType; },
/* harmony export */   "et": function() { return /* binding */ fullHeightVideoPart; },
/* harmony export */   "iQ": function() { return /* binding */ textPart; }
/* harmony export */ });
/* harmony import */ var constants_video_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39832);
/* harmony import */ var _constants_one_pager_asset_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30513);


var imageAlign = {
    type: "combo",
    label: "Desktop image alignment",
    options: [
        {
            value: "align-center",
            text: "Center"
        },
        {
            value: "align-top",
            text: "Top"
        },
        {
            value: "align-bottom",
            text: "Bottom"
        }
    ]
};
var textPart = {
    type: "nested",
    label: "Text Config",
    fields: {
        color: {
            type: "colorPicker",
            label: "Text Color",
            possibleColors: [
                "black",
                "white"
            ]
        },
        titleLines: {
            type: "multipleTexts",
            label: "Title Lines (Up to 2, 250 chars per line)",
            maxLimit: 2,
            maxLineChars: 250
        },
        titleLinesFontSize: {
            type: "text",
            label: "Desktop title lines font size"
        },
        subtitleLines: {
            type: "multipleTexts",
            label: "Subtitle Lines (Up to 2, 150 chars per line)",
            maxLimit: 2,
            maxLineChars: 150
        },
        bullets: {
            type: "multipleTexts",
            label: "Bullets (Up to 3)",
            maxLimit: 3
        },
        mobileTitleLines: {
            type: "multipleTexts",
            label: "Mobile Title Lines (Up to 3, if 3 subtitle won't appear, max 40 chars per line)",
            maxLimit: 3,
            maxLineChars: 40
        },
        mobileSubtitleLines: {
            type: "multipleTexts",
            label: "Mobile Subtitle Lines (Up to 2), max 40 chars per line",
            maxLimit: 3,
            maxLineChars: 40
        }
    }
};
var assetPart = {
    type: "dynamic",
    label: "Asset Type",
    types: {
        video: {
            type: "videoPicker",
            label: "Video Type",
            videoType: constants_video_types__WEBPACK_IMPORTED_MODULE_1__/* .FULL_PAGE_BACKGROUND_VIDEOS */ .bX
        }
    }
};
var fullHeightVideoPart = {
    type: "dynamic",
    label: "Asset Type",
    types: {
        video: {
            type: "videoPicker",
            label: "Video Type",
            videoType: constants_video_types__WEBPACK_IMPORTED_MODULE_1__/* .FULL_HEIGHT_VIDEOS */ .u6
        }
    }
};
var imageWithBackgroundPart = {
    type: "nested",
    label: "Image and Backgound",
    fields: {
        imageSegmentHeight: {
            type: "text",
            label: "The height of the first screen (Must be defined by vh)"
        },
        backgroundColor: {
            type: "colorPicker",
            label: "Background Color",
            possibleColors: [
                "brand-blue",
                "brand-purple",
                "brand-dark-blue",
                "brand-green",
                "transparent"
            ]
        },
        imageAlign: imageAlign,
        straightBorder: {
            type: "boolean",
            label: "Straight border"
        },
        src: {
            type: "gallery",
            defaultImagesKeys: [
                "static/img/templates/one-pager/boards/"
            ],
            label: "Select an image",
            options: [
                {
                    value: "/static/img/boards/board-with-cactus-and-phone.png",
                    text: "Board with cactus and phone"
                },
                {
                    value: "/static/img/boards/board-with-column-picker.jpg",
                    text: "Board with column picker"
                },
                {
                    value: "/static/img/boards/board-with-conversation.png",
                    text: "Board with conversation"
                },
                {
                    value: "/static/img/boards/board-with-earphones.png",
                    text: "Board with earphones"
                },
                {
                    value: "/static/img/boards/board-with-notifications.jpg",
                    text: "Board with notifications"
                },
                {
                    value: "/static/img/boards/board-with-pencils.png",
                    text: "Board with pencils"
                },
                {
                    value: "/static/img/boards/board-with-person-picker.jpg",
                    text: "Board with person picker"
                },
                {
                    value: "/static/img/boards/board-with-status-menu.jpg",
                    text: "Board with status menu"
                },
                {
                    value: "/static/img/boards/board-with-yellow-coffee-cup.png",
                    text: "Board with yellow coffee cup"
                },
                {
                    value: "/static/img/boards/cactus-with-board.png",
                    text: "Board with cactus"
                },
                {
                    value: "/static/img/boards/upload-file-board.jpg",
                    text: "Board with upload file"
                }
            ]
        },
        alt: {
            type: "text",
            label: "Image description (important for SEO)"
        }
    }
};
var mobileType = {
    type: "combo",
    label: "Select page mobile version",
    options: [
        {
            value: _constants_one_pager_asset_types__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_VERSIONS.MOBILE_BACKGROUND_GIF */ .m.MOBILE_BACKGROUND_GIF,
            text: "Mobile background gif"
        },
        {
            value: _constants_one_pager_asset_types__WEBPACK_IMPORTED_MODULE_0__/* .MOBILE_VERSIONS.MOBILE_ASSET */ .m.MOBILE_ASSET,
            text: "Mobile Asset"
        }
    ]
};
var mobileAssetType = {
    type: "gallery",
    label: "Mobile asset (Gif). Appears only in case mobile version is 'Mobile Asset'",
    defaultImagesKeys: [
        "static/img/templates/one-pager/mobile/"
    ]
};


/***/ }),

/***/ 60781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ signupForm; },
/* harmony export */   "x": function() { return /* binding */ signupFormWithDecorations; }
/* harmony export */ });
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

var signupForm = {
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Signup Config",
    fields: {
        buttonColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Button Color",
            possibleColors: [
                "space-blue",
                "dodger-blue",
                "blue",
                "iris",
                "white"
            ]
        },
        buttonText: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Button Text"
        },
        inputPlaceholder: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Input Placeholder"
        },
        showDownloadButtonOnMobile: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Show download button on mobile"
        },
        downloadButtonTitle: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Download button title"
        },
        placement: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "BigBrain Event Placement"
        },
        focusOnLoad: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Auto Focus"
        }
    }
};
var signupFormWithDecorationsConfig = signupForm;
signupFormWithDecorationsConfig.fields.showDecorations = {
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
    label: "Show decorations"
};
var signupFormWithDecorations = signupFormWithDecorationsConfig;


/***/ }),

/***/ 86922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iq": function() { return /* binding */ ADDABLE_TEMPLATE_TYPES; },
  "k6": function() { return /* binding */ TEMPLATE_TYPES; },
  "D$": function() { return /* binding */ getSegmentsConfig; },
  "Zi": function() { return /* binding */ getSegmentsDynamicsFetchMapper; },
  "wN": function() { return /* binding */ getTemplateConfig; }
});

// UNUSED EXPORTS: getTemplateConfigWithoutBase

// EXTERNAL MODULE: ./components/templates-generator/config/components/index.js + 20 modules
var components = __webpack_require__(75711);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./constants/templates-names.js
var templates_names = __webpack_require__(35015);
// EXTERNAL MODULE: ./constants/autocomplete-types.js
var autocomplete_types = __webpack_require__(25421);
var autocomplete_types_default = /*#__PURE__*/__webpack_require__.n(autocomplete_types);
// EXTERNAL MODULE: ./segments/desktop/index.js + 19 modules
var desktop = __webpack_require__(29107);
;// CONCATENATED MODULE: ./components/templates-generator/config/long-template/long-template-config.js

var LONG_TEMPLATE_CONFIG = {
    nameSignature: {
        type: "text",
        label: "Sign Your Name (optional)"
    },
    topbar: {
        type: "nested",
        label: "Topbar Config",
        fields: {
            preventMenu: {
                type: "boolean",
                label: "Prevent Menu"
            }
        }
    },
    socialButtons: {
        type: "nested",
        label: "Social Buttons",
        fields: {
            show: {
                type: "boolean",
                label: "Show social buttons"
            },
            color: {
                type: "colorPicker",
                label: "Text Color",
                possibleColors: [
                    "black",
                    "white"
                ]
            },
            blogStyle: {
                type: "boolean",
                label: "Blog style"
            }
        }
    },
    footer: {
        type: "nested",
        label: "Footer Config",
        fields: {
            preventFooter: {
                type: "boolean",
                label: "Prevent Footer"
            }
        }
    },
    segments: [
        {
            type: "ALL_SEGMENTS",
            title: "All Segmements",
            imgSrc: "/static/img/segments/icons/blank.png",
            segmentLayouts: [
                desktop/* default.HeaderWithImageAndTitle */.Z.HeaderWithImageAndTitle,
                desktop/* default.TwoColumnsWithCarousel */.Z.TwoColumnsWithCarousel
            ]
        }
    ],
    defaultData: {
        template: "LongTemplate",
        title: "",
        description: "",
        loginTheme: "light-theme",
        menuTheme: "light-theme",
        logoTheme: "light-color-theme",
        showMenu: true,
        segments: [
            {
                type: "HeaderWithImageAndTitle",
                props: {
                    title: "This is an <b>amazing title</b> akdgh awkjdhaw",
                    subtitle: "This is a subtitle",
                    backgroundColor: "brand-blue",
                    image: {
                        src: "/static/img/boards/board-with-cactus-and-phone.png",
                        alt: "",
                        shadow: false
                    },
                    textColor: "white"
                }
            },
            {
                type: "TwoColumnsWithCarousel",
                props: {
                    assetSide: "left",
                    content: {
                        title: "Bla bla content tite",
                        body: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
                        contentType: "paragraph"
                    },
                    asset: {
                        image: {
                            src: "/static/img/hp-top-monday-big-retina-4.png"
                        }
                    },
                    signupForm: {
                        with: true,
                        title: "Start using monday.com today"
                    },
                    hotDog: {
                        color: "brand-purple"
                    }
                }
            },
            {
                type: "TwoColumnsWithCarousel",
                props: {
                    assetSide: "right",
                    content: {
                        title: "Another section",
                        body: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
                        contentType: "list"
                    },
                    asset: {
                        image: {
                            src: "/static/img/hp-top-monday-big-retina-4.png"
                        }
                    },
                    hotDog: {
                        color: "brand-red"
                    }
                }
            }
        ]
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/segments-template/segments-template-config-default-data.js
var defaultData = {
    template: "SegmentsTemplate",
    title: "",
    description: "",
    theme: "dark-theme",
    mobileTheme: "dark-theme",
    imagesLazyLoad: false,
    showMenu: true,
    topbar: {
        showMenu: true
    },
    segments: []
};

;// CONCATENATED MODULE: ./components/templates-generator/config/segments-template/segments-template-config.js



var SEGMENTS_TEMPLATE_CONFIG = {
    topbar: components/* topbar */.lI,
    socialButtons: components/* socialButtons */.nc,
    footer: components/* footer */.Mv,
    segments: [
        {
            type: "ALL_SEGMENTS",
            title: "All Segmements",
            imgSrc: "/static/img/segments/icons/blank.png",
            segmentLayouts: [
                desktop/* default.VideosCarouselComponent */.Z.VideosCarouselComponent,
                desktop/* default.CompaniesLogosComponent */.Z.CompaniesLogosComponent,
                desktop/* default.TextAndAssetComponent */.Z.TextAndAssetComponent,
                desktop/* default.FormWithTextAndAssetsComponent */.Z.FormWithTextAndAssetsComponent,
                desktop/* default.SimpleColorfulTitleWithSignupComponent */.Z.SimpleColorfulTitleWithSignupComponent,
                desktop/* default.SwitchingTitleWithQuotesCarouselComponent */.Z.SwitchingTitleWithQuotesCarouselComponent,
                desktop/* default.LottieAnimationComponent */.Z.LottieAnimationComponent,
                desktop/* default.BoardViewsComponent */.Z.BoardViewsComponent,
                desktop/* default.CustomerSuccessComponent */.Z.CustomerSuccessComponent,
                desktop/* default.SecurityAndPrivacyComponent */.Z.SecurityAndPrivacyComponent,
                desktop/* default.IntegrationsComponent */.Z.IntegrationsComponent,
                desktop/* default.FactCardsComponent */.Z.FactCardsComponent,
                desktop/* default.ParagraphComponent */.Z.ParagraphComponent,
                desktop/* default.MultipleTabsComponent */.Z.MultipleTabsComponent,
                desktop/* default.MainYoutubeVideoComponent */.Z.MainYoutubeVideoComponent,
                desktop/* default.ButtonWithAnimationComponent */.Z.ButtonWithAnimationComponent,
                desktop/* default.SignupWithAnimationComponent */.Z.SignupWithAnimationComponent,
                desktop/* default.EmbeddedFormComponent */.Z.EmbeddedFormComponent,
                desktop/* default.SimpoComponent */.Z.SimpoComponent,
                desktop/* default.ClusterSelectionComponent */.Z.ClusterSelectionComponent,
                desktop/* default.ClusterSelectionOneStepComponent */.Z.ClusterSelectionOneStepComponent,
                desktop/* default.IndustrySelectionComponent */.Z.IndustrySelectionComponent,
                desktop/* default.OnePagerWithImageComponent */.Z.OnePagerWithImageComponent,
                desktop/* default.HeroImageComponent */.Z.HeroImageComponent,
                desktop/* default.ShortFooterComponent */.Z.ShortFooterComponent,
                desktop/* default.ReviewsComponent */.Z.ReviewsComponent,
                desktop/* default.SocialProofComponent */.Z.SocialProofComponent,
                desktop/* default.RegularAssetComponent */.Z.RegularAssetComponent
            ]
        }
    ],
    defaultData: defaultData
};

;// CONCATENATED MODULE: ./components/templates-generator/config/fixed-long-lp-template/fixed-long-lp-template-config.js


var FIXED_LONG_LP_TEMPLATE_CONFIG = {
    topbar: components/* topbar */.lI,
    socialButtons: components/* socialButtons */.nc,
    segments: [
        {
            type: "ALL_SEGMENTS",
            title: "All Segmements",
            imgSrc: "/static/img/segments/icons/blank.png",
            segmentLayouts: [
                desktop/* default.CompaniesLogosComponent */.Z.CompaniesLogosComponent,
                desktop/* default.TextAndAssetComponent */.Z.TextAndAssetComponent,
                desktop/* default.SimpleColorfulTitleWithSignupComponent */.Z.SimpleColorfulTitleWithSignupComponent,
                desktop/* default.CustomerSuccessComponent */.Z.CustomerSuccessComponent,
                desktop/* default.SecurityAndPrivacyComponent */.Z.SecurityAndPrivacyComponent,
                desktop/* default.ParagraphComponent */.Z.ParagraphComponent,
                desktop/* default.OnePagerWithImageComponent */.Z.OnePagerWithImageComponent,
                desktop/* default.ShortFooterComponent */.Z.ShortFooterComponent,
                desktop/* default.ReviewsComponent */.Z.ReviewsComponent
            ]
        }
    ],
    defaultData: {
        template: "FixedLongLpTemplate",
        title: "",
        description: "",
        theme: "dark-theme",
        mobileTheme: "dark-theme",
        imagesLazyLoad: false,
        showMenu: true,
        topbar: {
            showMenu: true
        },
        segments: [
            {
                type: "OnePagerWithImageComponent",
                props: {
                    imageWithBackgroundPart: {
                        backgroundColor: "transparent",
                        src: "/static/uploads/MayKishon/dceff356-89d1-4e10-8b1d-8426b7941763_board_teamprojects.png",
                        alt: "Time tracking and project management board",
                        imageSegmentHeight: "90vh",
                        straightBorder: false,
                        imageAlign: "align-center"
                    },
                    textPart: {
                        titleLines: [
                            "<b>Finally.</b> Track time & manage projects in one place",
                            ""
                        ],
                        subtitleLines: [
                            "Know how you spend your time and make every minute count."
                        ],
                        bullets: [],
                        mobileTitleLines: [
                            "<b>Track time with the </b>",
                            "<b>#1 productivity software</b>"
                        ],
                        mobileSubtitleLines: [
                            "",
                            ""
                        ],
                        color: "black",
                        titleLinesFontSize: "42px"
                    },
                    signupForm: {
                        buttonColor: "brand-pink",
                        buttonText: "Get Started",
                        inputPlaceholder: "Enter your work email",
                        downloadButtonTitle: "Download The App",
                        focusOnLoad: true
                    },
                    isFullWidth: true
                }
            },
            {
                type: "CompaniesLogosComponent",
                props: {
                    paragraph: {
                        title: "",
                        textDirection: "center"
                    },
                    signupForm: {
                        showDecorations: false
                    },
                    withAnimation: true,
                    showSignup: false,
                    numberOfCompanies: "5",
                    paddingBottom: "",
                    backgroundColor: "snow",
                    paddingTop: "20px"
                }
            },
            {
                type: "ParagraphComponent",
                props: {
                    title: "Track time and projects your way",
                    textDirection: "center",
                    paddingTop: "80px",
                    body: [
                        "Know exactly where projects stand and reach every milestone."
                    ]
                }
            },
            {
                type: "CustomerSuccessComponent",
                props: {
                    columnWidth: "300px",
                    imageWidth: "",
                    assets: [
                        {
                            asset: {
                                shadow: false,
                                image: {
                                    src: "/static/uploads/MayKishon/61389087-d6ab-4824-a031-99538572c7ad_Slice-2.png",
                                    alt: "timer"
                                }
                            },
                            content: {
                                title: "Exact time frames",
                                textDirection: "center",
                                body: [
                                    "Easily switch the timer on and off or enter time spent manually."
                                ],
                                bottomLink: {
                                    text: "",
                                    href: ""
                                },
                                topic: {
                                    text: ""
                                },
                                titleFontSize: "18px"
                            }
                        },
                        {
                            asset: {
                                shadow: false,
                                image: {
                                    src: "/static/uploads/MayKishon/b506f2f2-1ead-4df9-8894-3415e22d1675_Slice-1.png",
                                    alt: "mobile"
                                }
                            },
                            content: {
                                title: "On the go tracking",
                                textDirection: "center",
                                body: [
                                    "Track time anywhere, anytime with our mobile app."
                                ],
                                bottomLink: {
                                    text: "",
                                    href: ""
                                },
                                titleFontSize: "18px"
                            }
                        },
                        {
                            asset: {
                                shadow: false,
                                image: {
                                    src: "/static/uploads/MayKishon/9265883f-9c27-4957-9ce7-ee2699df1bc4_Slice.png",
                                    alt: "integrate"
                                }
                            },
                            content: {
                                title: "Integrate in no time",
                                textDirection: "center",
                                body: [
                                    "Integrate with your favorite tools and centralize your work in one place."
                                ],
                                bottomLink: {
                                    text: "",
                                    href: ""
                                },
                                topic: {
                                    text: ""
                                },
                                titleFontSize: "18px"
                            }
                        }
                    ],
                    paddingTop: "24px",
                    paddingBottom: "40px"
                }
            },
            {
                type: "SimpleColorfulTitleWithSignupComponent",
                props: {
                    title: "",
                    showSignup: true,
                    subtitle: "<b>Try monday.com time tracking tool </b>",
                    paddingTop: "40px",
                    paddingBottom: ""
                }
            },
            {
                type: "SimpleColorfulTitleWithSignupComponent",
                props: {
                    title: "Seamlessly turn your data into clear insights",
                    showSignup: false,
                    paddingTop: "80px"
                }
            },
            {
                type: "TextAndAssetComponent",
                props: {
                    content: {
                        topic: {
                            text: "",
                            color: "brand-blue"
                        },
                        title: "Stay on top of your time",
                        body: [
                            "Know exactly how much time is spent on each project and task. See who's working on what, and what's keeping you behind."
                        ],
                        bottomLink: {
                            href: "",
                            text: ""
                        },
                        titleFontSize: "28px"
                    },
                    asset: {
                        side: "right",
                        shadow: false,
                        video: {},
                        image: {
                            src: "/static/uploads/MayKishon/2b5c3545-e7e6-41bf-a36c-d6b1b581c663_Stayontime.png",
                            alt: "Easily track times and tasks"
                        }
                    },
                    backgroundColor: "white",
                    paddingBottom: "80px",
                    paddingTop: "80px"
                }
            },
            {
                type: "TextAndAssetComponent",
                props: {
                    content: {
                        topic: {
                            text: "",
                            color: "brand-blue"
                        },
                        title: "Create Flexible Reports",
                        body: [
                            "Analyse your data as you wish - see a breakdown of time by projects, clients and tasks - and make data-driven decisions."
                        ],
                        bottomLink: {
                            href: "",
                            text: ""
                        },
                        titleFontSize: "28px",
                        textDirection: "left"
                    },
                    asset: {
                        side: "left",
                        shadow: false,
                        video: {
                            playWhenVisible: false
                        },
                        image: {
                            src: "/static/uploads/MayKishon/bf4a862e-c115-42f6-89ca-93cd5396e39b_Dashboardstime.png",
                            alt: "Issue time sheets and reports"
                        }
                    },
                    paddingTop: "40px",
                    paddingBottom: "40px",
                    isFullWidth: false
                }
            },
            {
                type: "TextAndAssetComponent",
                props: {
                    content: {
                        topic: {
                            text: "",
                            color: "brand-blue"
                        },
                        title: "Set Smart Notifications",
                        body: [
                            "Immediately get notified when a task is done or when a project is past its due date. Set smart reminders for the stuff that matter to you the most - and always deliver on time."
                        ],
                        bottomLink: {
                            href: "",
                            text: ""
                        },
                        titleFontSize: "28px"
                    },
                    asset: {
                        side: "right",
                        shadow: false,
                        video: {
                            loop: false,
                            playWhenVisible: false
                        },
                        image: {
                            src: "/static/uploads/MayKishon/1eae46c3-03c9-45f9-8024-f036a618cfc8_notification.png",
                            alt: "Custom notifications & reminders"
                        }
                    },
                    paddingTop: "40px",
                    paddingBottom: "80px"
                }
            },
            {
                type: "ReviewsComponent",
                props: {
                    columnWidth: "350px",
                    reviews: [
                        {
                            reviewContent: [
                                '"The UI design is visually pleasing and makes the program easy to use.  The software can be easily customized for different types of projects. Time tracking is great and helps us account for time spent on any given project."'
                            ],
                            reviewerName: "Charles C.",
                            reviewedOn: "Capterra"
                        },
                        {
                            reviewContent: [
                                '"Checking numerous tools for project mgmt, monday.com stands out in simplicity of use, getting started right away and easy to share. monday.com gives me a full overview on running projects, as well as helping me keep track of the steps along the way. 5 stars of 5!"'
                            ],
                            reviewerName: "Lars D.",
                            reviewedOn: "Capterra"
                        }
                    ],
                    backgroundColor: "snow",
                    paddingTop: "40px",
                    paddingBottom: "40px"
                }
            },
            {
                type: "SimpleColorfulTitleWithSignupComponent",
                props: {
                    title: "Try monday.com <brand-blue>time tracking tool </brand-blue>",
                    showSignup: true,
                    paddingTop: "100px",
                    paddingBottom: "px"
                }
            },
            {
                type: "SecurityAndPrivacyComponent",
                props: {
                    assets: [
                        {
                            url: "/static/img/security/gdpr.png",
                            alt: "GDPR"
                        },
                        {
                            url: "/static/img/security/iso-27001.png",
                            alt: "ISO-27001"
                        },
                        {
                            url: "/static/img/security/iso-27018.png",
                            alt: "ISO-27018"
                        },
                        {
                            url: "/static/img/security/soc.png",
                            alt: "SOC"
                        }
                    ],
                    paragraph: {
                        textDirection: "center",
                        title: "",
                        body: [
                            ""
                        ]
                    },
                    backgroundColor: "white",
                    paddingBottom: "20px",
                    paddingTop: ""
                }
            },
            {
                type: "ShortFooterComponent",
                props: {
                    isFullWidth: true,
                    paddingTop: ""
                }
            },
            {
                type: "ParagraphComponent",
                props: {
                    title: "",
                    titleFontSize: "12px",
                    textDirection: "center",
                    backgroundColor: "snow",
                    paddingTop: ""
                }
            }
        ]
    }
};

// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
;// CONCATENATED MODULE: ./components/templates-generator/config/article-template/article-template-config.js



var ARTICLE_TEMPLATE_CONFIG = {
    nameSignature: {
        type: "text",
        label: "Sign Your Name (optional)"
    },
    socialButtons: {
        type: "nested",
        label: "Social Buttons",
        fields: {
            show: {
                type: "boolean",
                label: "Show social buttons"
            },
            color: {
                type: "colorPicker",
                label: "Text Color",
                possibleColors: [
                    "black",
                    "white"
                ]
            },
            blogStyle: {
                type: "boolean",
                label: "Blog style"
            }
        }
    },
    topbar: {
        type: "nested",
        label: "Topbar Config",
        fields: {
            preventMenu: {
                type: "boolean",
                label: "Prevent Menu"
            }
        }
    },
    headerStrip: {
        type: "nested",
        label: "Top section",
        fields: {
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            },
            preventSignup: {
                type: "boolean",
                label: "Prevent Signup"
            },
            asset: {
                type: "nested",
                label: "Image",
                fields: {
                    src: {
                        type: "gallery",
                        label: "Select an image",
                        defaultImagesKeys: [
                            "static/img/templates/articale/strips/"
                        ],
                        options: [
                            {
                                value: "/static/img/strips/strip-hands.jpg",
                                text: "Hands"
                            },
                            {
                                value: "/static/img/strips/strip-computer-board.jpg",
                                text: "Board"
                            },
                            {
                                value: "/static/img/strips/strip-people-table.jpg",
                                text: "Table"
                            },
                            {
                                value: "/static/img/strips/strip-photographer.jpg",
                                text: "Photographer"
                            },
                            {
                                value: "/static/img/strips/strip-working-together.jpg",
                                text: "Working Together"
                            }
                        ]
                    },
                    alt: {
                        type: "text",
                        label: "Image description (will not be visible)"
                    }
                }
            }
        }
    },
    parts: {
        type: "segments",
        types: {
            paragraph: {
                type: "nested",
                label: "Paragraph",
                fields: {
                    title: {
                        type: "text",
                        label: "Title (optional)"
                    },
                    content: {
                        type: "text",
                        label: "Content",
                        textArea: true
                    }
                }
            },
            signup: {
                type: "nested",
                label: "Signup Form",
                fields: {
                    title: {
                        type: "text",
                        label: "Title"
                    }
                }
            },
            image: {
                type: "nested",
                label: "Image",
                fields: {
                    src: {
                        type: "gallery",
                        label: "Select an image",
                        defaultImagesKeys: [
                            "static/img/templates/articale/segments/"
                        ],
                        options: [
                            {
                                value: "/static/img/boards/board-with-cactus-and-phone.png",
                                text: "Board with cactus and phone"
                            },
                            {
                                value: "/static/img/boards/board-with-column-picker.jpg",
                                text: "Board with column picker"
                            },
                            {
                                value: "/static/img/boards/board-with-conversation.png",
                                text: "Board with conversation"
                            },
                            {
                                value: "/static/img/boards/board-with-earphones.png",
                                text: "Board with earphones"
                            },
                            {
                                value: "/static/img/boards/board-with-notifications.jpg",
                                text: "Board with notifications"
                            },
                            {
                                value: "/static/img/boards/board-with-pencils.png",
                                text: "Board with pencils"
                            },
                            {
                                value: "/static/img/boards/board-with-person-picker.jpg",
                                text: "Board with person picker"
                            },
                            {
                                value: "/static/img/boards/board-with-status-menu.jpg",
                                text: "Board with status menu"
                            },
                            {
                                value: "/static/img/boards/board-with-yellow-coffee-cup.png",
                                text: "Board with yellow coffee cup"
                            },
                            {
                                value: "/static/img/boards/cactus-with-board.png",
                                text: "Board with cactus"
                            },
                            {
                                value: "/static/img/boards/upload-file-board.jpg",
                                text: "Board with upload file"
                            },
                            {
                                value: "/static/img/boards/board-with-pencils-and-earphones.png",
                                text: "Board with pencils and earphones"
                            },
                            {
                                value: "/static/img/boards/board-with-timeline-and-cactus.png",
                                text: "Board with timeline and cactus"
                            },
                            {
                                value: "/static/img/boards/board-with-green-bricks.png",
                                text: "Board with green bricks"
                            },
                            {
                                value: "/static/img/header/phone-app-with-desk.jpg",
                                text: "Mobile app with desk"
                            },
                            {
                                value: "/static/img/header/phone-app.jpg",
                                text: "Mobile app"
                            },
                            {
                                value: "/static/img/header/desktop.jpg",
                                text: "Laptop on a desk"
                            },
                            {
                                value: "/static/img/header/leah-joel.jpg",
                                text: "Leah & Joel"
                            },
                            {
                                value: "/static/img/header/stav.jpg",
                                text: "Stav"
                            },
                            {
                                value: "/static/img/header/emily.jpg",
                                text: "Emily with timeline"
                            },
                            {
                                value: "/static/img/header/lupo.jpg",
                                text: "Lupo"
                            },
                            {
                                value: "/static/img/header/asaf-aviram.jpg",
                                text: "Asaf & Aviram"
                            },
                            {
                                value: "/static/img/header/aviram-lior.jpg",
                                text: "Aviram & Lior"
                            },
                            {
                                value: "/static/img/header/elina.jpg",
                                text: "Elina"
                            },
                            {
                                value: "/static/img/header/tan.jpg",
                                text: "Tan"
                            }
                        ],
                        otherOption: {
                            text: "Put your own URL...",
                            inputPlaceholder: "Put your own URL..."
                        }
                    },
                    alt: {
                        type: "text",
                        label: "Image description (will not be visible)"
                    }
                }
            },
            highlight: {
                type: "nested",
                label: "Highlight / Quote",
                fields: {
                    content: {
                        type: "text",
                        textArea: true
                    }
                }
            },
            comparisonTable: components/* comparisonTable */.MV
        }
    },
    footerSignup: {
        type: "nested",
        label: "Bottom Signup Form",
        fields: {
            preventSignup: {
                type: "boolean",
                label: "Prevent Signup"
            },
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            }
        }
    },
    footer: {
        type: "nested",
        label: "Footer Config",
        fields: {
            preventFooter: {
                type: "boolean",
                label: "Prevent Footer"
            },
            disclaimer: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Disclaimer"
            }
        }
    },
    defaultData: {
        template: "ArticleTemplate",
        title: "Article Page Example Title",
        description: "Article Page Example Description",
        headerStrip: {
            title: "We’ve made a simple and visual CRM tool",
            subtitle: "Manage your workload, communicate with your team, and celebrate success",
            asset: {
                assetType: "picture",
                src: "/static/img/strips/strip-hands.jpg"
            }
        },
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        },
        parts: []
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/directory-images-template/default-data.js
var default_data_defaultData = {
    template: "DirectoryImagesTemplate",
    title: "Article Page Example Title",
    description: "Article Page Example Description",
    header: {
        color: "brand-red",
        text: "Use Cases",
        height: "360px",
        img: "/static/img/header-decorators/tablet-chocolat.png",
        hotDogColor: "brand-red",
        textColor: "white",
        title: "Example and use cases",
        subtitle: "Here you can find the best examples and use case<br/> Hilli you are amazing :)"
    },
    listData: [
        {
            type: "link",
            props: {
                firstTitle: {
                    text: "My title for thumbnail"
                },
                color: "brand-red",
                subtitle: "Another subtitle with long text",
                image: "/static/img/thumbnails/animated-lock-icon.jpg",
                link: "/link678",
                buttomLink: {
                    show: true,
                    text: "Read more >",
                    url: "/link678",
                    color: "brand-blue"
                }
            }
        }
    ],
    footerSignup: {},
    socialButtons: {
        show: false
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/directory-images-template/directory-images-template-config.js


var DIRECTORY_IMAGES_TEMPLATE_CONFIG = {
    socialButtons: components/* socialButtons */.nc,
    header: {
        type: "nested",
        label: "Top section",
        fields: {
            hotDogColor: {
                type: "colorPicker",
                label: "Hotdog color"
            },
            textColor: {
                type: "colorPicker",
                label: "Text Color",
                possibleColors: [
                    "black",
                    "white"
                ]
            },
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            },
            searchConfig: {
                type: "nested",
                fields: {
                    show: {
                        type: "boolean",
                        label: "Show Search"
                    },
                    placeholder: {
                        type: "text",
                        label: "Search Placeholder"
                    }
                }
            },
            img: {
                type: "gallery",
                defaultImagesKeys: [
                    "static/img/templates/directory-images/header-decorators/"
                ],
                label: "Select an image"
            }
        }
    },
    listData: components/* directoryListData */.dt,
    defaultData: default_data_defaultData
};

;// CONCATENATED MODULE: ./components/templates-generator/config/multiple-directory-images-template/default-data.js
var multiple_directory_images_template_default_data_defaultData = {
    template: "MultipleDirectoryImagesTemplate",
    title: "example title",
    description: "example description",
    header: {
        color: "brand-red",
        text: "Use Cases",
        height: "360px",
        img: "/static/img/header-decorators/tablet-chocolat.png",
        hotDogColor: "brand-red",
        textColor: "white",
        title: "Example and use cases",
        subtitle: "Here you can find the best examples and use case<br/> Hilli you are amazing :)"
    },
    directories: [
        {
            type: "directory",
            props: {
                title: "Directory title",
                titleColor: "brand-red",
                listData: [
                    {
                        type: "link",
                        props: {
                            firstTitle: {
                                text: "My title for thumbnail"
                            },
                            color: "brand-red",
                            subtitle: "Another subtitle with long text",
                            image: "/static/img/thumbnails/animated-lock-icon.jpg",
                            link: "/link678",
                            buttomLink: {
                                show: true,
                                text: "Read more >",
                                url: "/link678",
                                color: "brand-blue"
                            }
                        }
                    }
                ]
            }
        }
    ],
    footerSignup: {},
    socialButtons: {
        show: false
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/multiple-directory-images-template/multiple-directory-images-template-config.js


var MULTIPLE_DIRECTORY_IMAGES_TEMPLATE_CONFIG = {
    socialButtons: components/* socialButtons */.nc,
    header: {
        type: "nested",
        label: "Top section",
        fields: {
            hotDogColor: {
                type: "colorPicker",
                label: "Hotdog color"
            },
            textColor: {
                type: "colorPicker",
                label: "Text Color",
                possibleColors: [
                    "black",
                    "white"
                ]
            },
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            },
            searchConfig: {
                type: "nested",
                fields: {
                    show: {
                        type: "boolean",
                        label: "Show Search"
                    },
                    placeholder: {
                        type: "text",
                        label: "Search Placeholder"
                    }
                }
            },
            img: {
                type: "gallery",
                label: "Select an image",
                defaultImagesKeys: [
                    "static/img/templates/directory-images/header-decorators/"
                ],
                options: [
                    {
                        value: "/static/img/header-decorators/app-and-cofee.png",
                        text: "App and Cofee"
                    },
                    {
                        value: "/static/img/header-decorators/computer-cofee.png",
                        text: "Computer and Cofee"
                    },
                    {
                        value: "/static/img/header-decorators/headphone-and-mouse.png",
                        text: "Headphones and Mouse"
                    },
                    {
                        value: "/static/img/header-decorators/papers-and-paint.png",
                        text: "Papers and Paint"
                    },
                    {
                        value: "/static/img/header-decorators/tablet-chocolat.png",
                        text: "Tablet and Chocolat"
                    }
                ]
            }
        }
    },
    directories: {
        type: "segments",
        label: "Directories",
        types: {
            directory: {
                type: "nested",
                fields: {
                    title: {
                        type: "text",
                        label: "Title"
                    },
                    titleColor: {
                        type: "colorPicker",
                        label: "Title Color"
                    },
                    listData: components/* directoryListData */.dt
                }
            }
        }
    },
    defaultData: multiple_directory_images_template_default_data_defaultData
};

// EXTERNAL MODULE: ./components/templates-generator/config/segments/social-proof/social-proof-config.js
var social_proof_config = __webpack_require__(18019);
// EXTERNAL MODULE: ./components/templates-generator/config/segments/short-footer/short-footer-config.js
var short_footer_config = __webpack_require__(56903);
;// CONCATENATED MODULE: ./components/templates-generator/config/one-pager-asset-template/one-pager-asset-template-config.js




var ONE_PAGER_ASSET_TEMPLATE_CONFIG = {
    nameSignature: {
        type: "text",
        label: "Sign Your Name (optional)"
    },
    socialButtons: components/* socialButtons */.nc,
    assetPart: components/* onePagerAssetPart */.IO,
    textPart: components/* onePagerTextPart */.Lk,
    mobileVersion: components/* onePagerMobileType */.hh,
    mobileAssetType: components/* onePagerMobileAssetType */.y6,
    collaborationWith: components/* collaborationWith */.Gx,
    popupVideo: components/* popupVideo */.NH,
    signupForm: components/* signupForm */.L,
    SocialProof: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Social Proof",
        fields: {
            showSocialProof: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Social Proof"
            },
            content: social_proof_config/* default */.Z
        }
    },
    ShortFooter: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Short Footer",
        fields: {
            showShortFooter: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Short Footer"
            },
            content: short_footer_config/* default */.Z
        }
    },
    defaultData: {
        template: "OnePagerAssetTemplate",
        assetPart: {
            type: "video",
            props: {
                formats: [
                    "/static/video/one-pager/status-video.mp4",
                    "/static/video/one-pager/status-video.ogv"
                ],
                poster: "/static/video/one-pager/status-video-poster.jpg"
            }
        },
        textPart: {
            titleLines: [
                "Project Management",
                "<b>is better when it's visual</b>"
            ],
            subtitleLines: [
                "See what everyone on your team is working on in a single glance"
            ],
            bullets: [
                "Manage your projects & tasks with ease",
                "Plan visually on a timeline",
                "Centralize communication in one place"
            ],
            mobileTitleLines: [
                "Project Management",
                "<b>is better when it's visual</b>"
            ],
            mobileSubtitleLines: [
                "See what everyone on your team",
                "is working on in a single glance"
            ],
            color: "black"
        },
        collaborationWith: {
            show: false,
            color: "black",
            text: "Powered By"
        },
        popupVideo: {
            show: false,
            videoId: "21NBzs5juJk",
            playButtonText: "Watch a demo",
            footerText: "Simplify the way your team works"
        },
        signupForm: {
            buttonColor: "brand-pink",
            buttonText: "Get Started",
            inputPlaceholder: "Enter your work email",
            downloadButtonTitle: "Download The App"
        },
        SocialProof: {
            showSocialProof: false,
            content: {
                CompaniesLogos: {
                    paragraph: {},
                    showSignup: false
                },
                Reviews: {
                    columnWidth: "350px",
                    reviews: [
                        {
                            reviewContent: [
                                '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                            ],
                            reviewerName: "Dotan Egozi, monday.com"
                        },
                        {
                            reviewContent: [
                                '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                            ],
                            reviewerName: "Dotan Egozi, monday.com"
                        }
                    ]
                }
            }
        },
        ShowShortFooter: {
            showShortFooter: false
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/one-pager-with-image-template/default-data.js
var one_pager_with_image_template_default_data_defaultData = {
    template: "OnePagerWithImageTemplate",
    footer: {
        preventFooter: true
    },
    topbar: {
        showMenu: false
    },
    imageWithBackgroundPart: {
        backgroundColor: "brand-blue",
        src: "/static/img/boards/board-with-pencils.png",
        alt: "",
        imageSegmentHeight: "100vh"
    },
    textPart: {
        titleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        subtitleLines: [
            "See what everyone on your team is working on in a single glance"
        ],
        bullets: [
            "Manage your projects & tasks with ease",
            "Plan visually on a timeline",
            "Centralize communication in one place"
        ],
        mobileTitleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        mobileSubtitleLines: [
            "See what everyone on your team",
            "is working on in a single glance"
        ],
        color: "black"
    },
    collaborationWith: {
        show: false,
        color: "black",
        text: "Powered By"
    },
    SocialProof: {
        showSocialProof: false,
        content: {
            CompaniesLogos: {
                paragraph: {},
                showSignup: false
            },
            Reviews: {
                columnWidth: "350px",
                reviews: [
                    {
                        reviewContent: [
                            '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                        ],
                        reviewerName: "Dotan Egozi, monday.com"
                    },
                    {
                        reviewContent: [
                            '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                        ],
                        reviewerName: "Dotan Egozi, monday.com"
                    }
                ]
            }
        }
    },
    ShowShortFooter: {
        showShortFooter: false
    },
    signupForm: {
        buttonColor: "brand-pink",
        buttonText: "Get Started",
        inputPlaceholder: "Enter your work email",
        downloadButtonTitle: "Download The App"
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/one-pager-with-image-template/one-pager-with-image-template-config.js





var ONE_PAGER_WITH_IMAGE_TEMPLATE_CONFIG = {
    topbar: components/* topbar */.lI,
    footer: components/* footer */.Mv,
    socialButtons: components/* socialButtons */.nc,
    imageWithBackgroundPart: components/* onePagerImageWithBackgroundPart */.HJ,
    textPart: components/* onePagerTextPart */.Lk,
    signupForm: components/* signupForm */.L,
    collaborationWith: components/* collaborationWith */.Gx,
    SocialProof: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Social Proof",
        fields: {
            showSocialProof: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Social Proof"
            },
            content: social_proof_config/* default */.Z
        }
    },
    ShortFooter: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Short Footer",
        fields: {
            showShortFooter: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Short Footer"
            },
            content: short_footer_config/* default */.Z
        }
    },
    defaultData: one_pager_with_image_template_default_data_defaultData
};

;// CONCATENATED MODULE: ./components/templates-generator/config/mobile-one-pager-with-image-template/default-data.js
var mobile_one_pager_with_image_template_default_data_defaultData = {
    template: "MobileOnePagerWithImageTemplate",
    footer: {
        preventFooter: true
    },
    topbar: {
        showMenu: false
    },
    imageWithBackgroundPart: {
        backgroundColor: "brand-blue",
        src: "/static/img/boards/board-with-pencils.png",
        alt: "",
        imageSegmentHeight: "100vh"
    },
    textPart: {
        titleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        subtitleLines: [
            "See what everyone on your team is working on in a single glance"
        ],
        bullets: [
            "Manage your projects & tasks with ease",
            "Plan visually on a timeline",
            "Centralize communication in one place"
        ],
        mobileTitleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        mobileSubtitleLines: [
            "See what everyone on your team",
            "is working on in a single glance"
        ],
        color: "black"
    },
    collaborationWith: {
        show: false,
        color: "black",
        text: "Powered By"
    },
    signupForm: {
        buttonColor: "brand-pink",
        buttonText: "Get Started",
        inputPlaceholder: "Enter your work email",
        downloadButtonTitle: "Download The App"
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/mobile-one-pager-with-image-template/mobile-one-pager-with-image-template-config.js


var MOBILE_ONE_PAGER_WITH_IMAGE_TEMPLATE_CONFIG = {
    topbar: components/* topbar */.lI,
    footer: components/* footer */.Mv,
    socialButtons: components/* socialButtons */.nc,
    imageWithBackgroundPart: components/* onePagerImageWithBackgroundPart */.HJ,
    textPart: components/* onePagerTextPart */.Lk,
    signupForm: components/* signupForm */.L,
    collaborationWith: components/* collaborationWith */.Gx,
    defaultData: mobile_one_pager_with_image_template_default_data_defaultData
};

;// CONCATENATED MODULE: ./components/templates-generator/config/one-pager-with-video-template/one-pager-with-video-template-config.js

var ONE_PAGER_WITH_VIDEO_TEMPLATE_CONFIG = {
    socialButtons: components/* socialButtons */.nc,
    assetPart: components/* onePagerFullHeightVideoPart */.OX,
    popupVideo: components/* popupVideo */.NH,
    textPart: components/* onePagerTextPart */.Lk,
    signupForm: components/* signupForm */.L,
    collaborationWith: components/* collaborationWith */.Gx,
    defaultData: {
        template: "OnePagerWithVideoTemplate",
        assetPart: {
            type: "video",
            props: {
                formats: [
                    "/static/video/one-pager-full-height/stuck-board-video.mp4",
                    "/static/video/one-pager-full-height/stuck-board-video.ogv"
                ],
                poster: "/static/video/one-pager-full-height/stuck-board-poster.png"
            }
        },
        popupVideo: {
            show: true,
            videoId: "1UbaEcto56k",
            playButtonText: "Play a 60 sec intro video",
            footerText: "Simplify the way your team works"
        },
        textPart: {
            titleLines: [
                "Project Management",
                "<b>is better when it's visual</b>"
            ],
            subtitleLines: [
                "See what everyone on your team is working on in a single glance"
            ],
            bullets: [
                "Manage your projects & tasks with ease",
                "Plan visually on a timeline",
                "Centralize communication in one place"
            ],
            mobileTitleLines: [
                "Project Management",
                "<b>is better when it's visual</b>"
            ],
            mobileSubtitleLines: [
                "See what everyone on your team",
                "is working on in a single glance"
            ],
            color: "black"
        },
        collaborationWith: {
            show: false,
            color: "black",
            text: "Powered By"
        },
        signupForm: {
            buttonColor: "brand-pink",
            buttonText: "Get Started",
            inputPlaceholder: "Enter your work email",
            downloadButtonTitle: "Download The App"
        }
    }
};

;// CONCATENATED MODULE: ./components/templates-generator/config/competitor-template/competitor-template-config.js


var COMPETITOR_TEMPLATE_CONFIG = {
    nameSignature: {
        type: "text",
        label: "Sign Your Name (optional)"
    },
    socialButtons: {
        type: "nested",
        label: "Social Buttons",
        fields: {
            show: {
                type: "boolean",
                label: "Show social buttons"
            },
            color: {
                type: "colorPicker",
                label: "Text Color",
                possibleColors: [
                    "black",
                    "white"
                ]
            },
            blogStyle: {
                type: "boolean",
                label: "Blog style"
            }
        }
    },
    footer: {
        type: "nested",
        label: "Footer Config",
        fields: {
            preventFooter: {
                type: "boolean",
                label: "Prevent Footer"
            },
            disclaimer: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Disclaimer"
            }
        }
    },
    topSection: {
        type: "nested",
        label: "Top Section",
        fields: {
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            },
            bullets: {
                type: "multipleTexts",
                text: "Bullets"
            },
            asset: {
                type: "nested",
                label: "Image",
                fields: {
                    shadow: {
                        type: "boolean"
                    },
                    image: {
                        type: "nested",
                        label: "Image",
                        fields: {
                            src: {
                                type: "gallery",
                                label: "Select an image",
                                defaultImagesKeys: [
                                    "static/img/templates/competitor/boards/"
                                ],
                                options: [
                                    {
                                        value: "/static/img/boards/board-with-cactus-and-phone.png",
                                        text: "Board with cactus and phone"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-column-picker.jpg",
                                        text: "Board with column picker"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-conversation.png",
                                        text: "Board with conversation"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-earphones.png",
                                        text: "Board with earphones"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-notifications.jpg",
                                        text: "Board with notifications"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-pencils.png",
                                        text: "Board with pencils"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-person-picker.jpg",
                                        text: "Board with person picker"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-status-menu.jpg",
                                        text: "Board with status menu"
                                    },
                                    {
                                        value: "/static/img/boards/board-with-yellow-coffee-cup.png",
                                        text: "Board with yellow coffee cup"
                                    },
                                    {
                                        value: "/static/img/boards/cactus-with-board.png",
                                        text: "Board with cactus"
                                    },
                                    {
                                        value: "/static/img/boards/upload-file-board.jpg",
                                        text: "Board with upload file"
                                    }
                                ],
                                otherOption: {
                                    text: "Put your own URL...",
                                    inputPlaceholder: "Put your own URL..."
                                }
                            },
                            widthPercentage: {
                                type: "text",
                                label: "Image width % (Optional, 50-100)"
                            },
                            alt: {
                                type: "text",
                                label: "Image description (alt)"
                            }
                        }
                    }
                }
            },
            hotDog: {
                type: "nested",
                label: "Hot Dog",
                fields: {
                    color: {
                        type: "colorPicker",
                        label: "Color"
                    }
                }
            }
        }
    },
    comparisonTable: components/* comparisonTable */.MV,
    footerSignup: {
        type: "nested",
        label: "Bottom Signup Form",
        fields: {
            title: {
                type: "text",
                label: "Title"
            },
            subtitle: {
                type: "text",
                label: "Subtitle"
            }
        }
    },
    defaultData: {
        template: "CompetitorTemplate",
        topSection: {
            hotDog: {
                color: "brand-yellow"
            },
            asset: {
                image: {
                    src: "/static/img/boards/board-with-cactus-and-phone.png"
                }
            },
            title: "May the best</br> product win!",
            subtitle: "monday.com is powerful enough to track everything your team is working on—so you can get results.",
            bullets: [
                "Manage your projects & tasks with ease ",
                "Plan visually on a timeline",
                "Centralize communication in one place"
            ]
        },
        comparisonTable: {
            title: "May the best product win!",
            subtitle: "monday.com is powerful enough to track everything your team is working on—so you can get results.",
            features: []
        }
    }
};

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/default-props.js
var default_props = __webpack_require__(32777);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/base-footer/default-props.js
var base_footer_default_props = __webpack_require__(96564);
;// CONCATENATED MODULE: ./components/templates-generator/config/desktop-dynamic-template/default-data.js



var desktop_dynamic_template_default_data_defaultData = {
    template: templates_names.TEMPLATE_NAMES.DynamicTemplate,
    theme: "dark-theme",
    mobileTheme: "dark-theme",
    imagesLazyLoad: false,
    segments: [
        {
            type: "BaseHeaderComponent",
            props: default_props/* default */.Z
        },
        {
            type: "BaseFooterComponent",
            props: base_footer_default_props/* default */.Z
        }
    ]
};

// EXTERNAL MODULE: ./segments/desktop/templates/index.js + 10 modules
var templates = __webpack_require__(34102);
// EXTERNAL MODULE: ./segments/desktop/shape/index.js + 17 modules
var shape = __webpack_require__(20655);
// EXTERNAL MODULE: ./segments/desktop/pricing/index.js
var pricing = __webpack_require__(49643);
// EXTERNAL MODULE: ./segments/desktop/form/index.js + 25 modules
var desktop_form = __webpack_require__(91805);
// EXTERNAL MODULE: ./segments/desktop/blog/index.js + 4 modules
var blog = __webpack_require__(24646);
// EXTERNAL MODULE: ./segments/desktop/iframe/index.js + 16 modules
var iframe = __webpack_require__(27044);
// EXTERNAL MODULE: ./segments/desktop/embedded/index.js + 8 modules
var embedded = __webpack_require__(17071);
// EXTERNAL MODULE: ./segments/desktop/banner/index.js + 8 modules
var banner = __webpack_require__(57095);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/index.js + 40 modules
var homepage_first_fold = __webpack_require__(40216);
// EXTERNAL MODULE: ./segments/desktop/integrations/index.js + 7 modules
var integrations = __webpack_require__(17082);
// EXTERNAL MODULE: ./segments/desktop/button/index.js + 4 modules
var desktop_button = __webpack_require__(3993);
// EXTERNAL MODULE: ./segments/desktop/enterprise/index.js + 10 modules
var enterprise = __webpack_require__(26647);
// EXTERNAL MODULE: ./segments/desktop/asset/index.js + 25 modules
var asset = __webpack_require__(13657);
// EXTERNAL MODULE: ./segments/desktop/header/index.js + 19 modules
var header = __webpack_require__(35471);
// EXTERNAL MODULE: ./segments/desktop/footer/index.js + 16 modules
var footer = __webpack_require__(31721);
// EXTERNAL MODULE: ./segments/desktop/grid/index.js + 77 modules
var grid = __webpack_require__(61057);
// EXTERNAL MODULE: ./segments/desktop/testimonials/index.js + 8 modules
var testimonials = __webpack_require__(35341);
// EXTERNAL MODULE: ./segments/desktop/logos/index.js + 18 modules
var logos = __webpack_require__(20906);
// EXTERNAL MODULE: ./segments/desktop/reviews/index.js + 17 modules
var reviews = __webpack_require__(80411);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/index.js + 51 modules
var text_and_asset = __webpack_require__(85144);
// EXTERNAL MODULE: ./segments/desktop/paragraph/index.js + 22 modules
var paragraph = __webpack_require__(27185);
// EXTERNAL MODULE: ./segments/desktop/tabs/index.js + 70 modules
var tabs = __webpack_require__(87918);
// EXTERNAL MODULE: ./segments/desktop/security/index.js + 4 modules
var security = __webpack_require__(71380);
;// CONCATENATED MODULE: ./components/templates-generator/config/desktop-dynamic-template/desktop-dynamic-template-config.js

// plop_marker:segments_import























var DESKTOP_DYNAMIC_TEMPLATE_CONFIG = {
    segments: [
        // plop_marker:add_segment_config
        {
            type: "TEXT_AND_ASSET",
            title: "Text And Asset",
            imgSrc: "/static/img/segments/icons/text-and-asset.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_text-and-asset
                text_and_asset/* default.ProductCardsSideBySideTextAndAssetComponent */.Z.ProductCardsSideBySideTextAndAssetComponent,
                text_and_asset/* default.WhatsNewInnerPageSideBySideTextAndAssetComponent */.Z.WhatsNewInnerPageSideBySideTextAndAssetComponent,
                text_and_asset/* default.SideBySideWithIconsTextAndAssetComponent */.Z.SideBySideWithIconsTextAndAssetComponent,
                text_and_asset/* default.TwoThirdsTextAndAssetComponent */.Z.TwoThirdsTextAndAssetComponent,
                text_and_asset/* default.FullBackgroundTextAndAssetComponent */.Z.FullBackgroundTextAndAssetComponent,
                text_and_asset/* default.SideBySideWithBackgroundTextAndAssetComponent */.Z.SideBySideWithBackgroundTextAndAssetComponent,
                text_and_asset/* default.SideBySideTextAndAssetComponent */.Z.SideBySideTextAndAssetComponent,
                text_and_asset/* default.SideBySideWithBulletsTextAndAssetComponent */.Z.SideBySideWithBulletsTextAndAssetComponent,
                text_and_asset/* default.TestimonialsTextAndAssetComponent */.Z.TestimonialsTextAndAssetComponent,
                text_and_asset/* default.BoardTabTextAndAssetComponent */.Z.BoardTabTextAndAssetComponent,
                text_and_asset/* default.YoutubeTextAndAssetComponent */.Z.YoutubeTextAndAssetComponent,
                text_and_asset/* default.YoutubeTwoThirdsTextAndAssetComponent */.Z.YoutubeTwoThirdsTextAndAssetComponent,
                text_and_asset/* default.AsymmetricSideBySideTextAndAssetComponent */.Z.AsymmetricSideBySideTextAndAssetComponent
            ]
        },
        {
            type: "ASSET",
            title: "Asset",
            imgSrc: "/static/img/segments/icons/asset.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_asset
                asset/* default.FadeInAssetComponent */.Z.FadeInAssetComponent,
                asset/* default.VideoBackgroundAssetComponent */.Z.VideoBackgroundAssetComponent,
                asset/* default.CarouselAssetComponent */.Z.CarouselAssetComponent,
                asset/* default.VerticalTagsWithImagesAssetComponent */.Z.VerticalTagsWithImagesAssetComponent,
                asset/* default.ImagesCarouselWithTagsGridAssetComponent */.Z.ImagesCarouselWithTagsGridAssetComponent,
                asset/* default.RegularAssetComponent */.Z.RegularAssetComponent,
                asset/* default.EmbeddedYoutubeAssetComponent */.Z.EmbeddedYoutubeAssetComponent,
                asset/* default.YoutubeVideoAssetComponent */.Z.YoutubeVideoAssetComponent
            ]
        },
        {
            type: "PARAGRAPH",
            title: "Paragraph",
            imgSrc: "/static/img/segments/icons/paragraph.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_paragraph
                paragraph/* default.FullParagraphComponent */.Z.FullParagraphComponent,
                paragraph/* default.TitleOnlyParagraphComponent */.Z.TitleOnlyParagraphComponent,
                paragraph/* default.FullWithBulletsParagraphComponent */.Z.FullWithBulletsParagraphComponent,
                paragraph/* default.RotatingTitleParagraphComponent */.Z.RotatingTitleParagraphComponent,
                paragraph/* default.SideBySideTitleParagraphComponent */.Z.SideBySideTitleParagraphComponent,
                paragraph/* default.UniverseParagraphComponent */.Z.UniverseParagraphComponent,
                paragraph/* default.TwoParagraphsParagraphComponent */.Z.TwoParagraphsParagraphComponent,
                paragraph/* default.SideBySideWithParagraphsParagraphComponent */.Z.SideBySideWithParagraphsParagraphComponent
            ]
        },
        {
            type: "GRID",
            title: "Grid",
            imgSrc: "/static/img/segments/icons/grid.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_grid
                grid/* default.BackgroundImageCardsGridComponent */.Z.BackgroundImageCardsGridComponent,
                grid/* default.AnimatedIconsGridComponent */.Z.AnimatedIconsGridComponent,
                grid/* default.MarqueeCardsGridComponent */.Z.MarqueeCardsGridComponent,
                grid/* default.HoverableCardsGridComponent */.Z.HoverableCardsGridComponent,
                grid/* default.MarqueeGridComponent */.Z.MarqueeGridComponent,
                grid/* default.BadgesGridComponent */.Z.BadgesGridComponent,
                grid/* default.SlidingCardGridComponent */.Z.SlidingCardGridComponent,
                grid/* default.FlexibleCardsGridComponent */.Z.FlexibleCardsGridComponent,
                grid/* default.SquareTagsGridComponent */.Z.SquareTagsGridComponent,
                grid/* default.IconWithParagraphGridComponent */.Z.IconWithParagraphGridComponent,
                grid/* default.BlogCardsGridComponent */.Z.BlogCardsGridComponent,
                grid/* default.CardsGridComponent */.Z.CardsGridComponent,
                grid/* default.TagsGridComponent */.Z.TagsGridComponent,
                grid/* default.SelectableTagsGridComponent */.Z.SelectableTagsGridComponent,
                grid/* default.ImageWithParagraphGridComponent */.Z.ImageWithParagraphGridComponent,
                grid/* default.OnlyImageGridComponent */.Z.OnlyImageGridComponent,
                grid/* default.ButtonTagsGridComponent */.Z.ButtonTagsGridComponent,
                grid/* default.ButtonImageTagsGridComponent */.Z.ButtonImageTagsGridComponent,
                grid/* default.TagItemsGridComponent */.Z.TagItemsGridComponent,
                grid/* default.SelectableTagsWithCarouselGridComponent */.Z.SelectableTagsWithCarouselGridComponent,
                grid/* default.MasonryGridComponent */.Z.MasonryGridComponent,
                grid/* default.ProductCardsGridComponent */.Z.ProductCardsGridComponent,
                grid/* default.PressGridComponent */.Z.PressGridComponent
            ]
        },
        {
            type: "TEMPLATES",
            title: "Templates",
            imgSrc: "/static/img/segments/icons/templates.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_templates
                templates/* default.SingleTemplateTemplatesComponent */.Z.SingleTemplateTemplatesComponent,
                templates/* default.MultiTemplatesTemplatesComponent */.Z.MultiTemplatesTemplatesComponent
            ]
        },
        {
            type: "BUTTON",
            title: "Button",
            imgSrc: "/static/img/segments/icons/button.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_button
                desktop_button/* default.BasicButtonComponent */.Z.BasicButtonComponent
            ]
        },
        {
            type: "TABS",
            title: "Tabs",
            imgSrc: "/static/img/segments/icons/tabs.png",
            divider: true,
            segmentLayouts: [
                // plop_marker:add_layout_config_tabs
                tabs/* default.CarouselTabsComponent */.Z.CarouselTabsComponent,
                tabs/* default.UsecasesGalleryTabsComponent */.Z.UsecasesGalleryTabsComponent,
                tabs/* default.SideBySideProductSwitcherWithProductTabsComponent */.Z.SideBySideProductSwitcherWithProductTabsComponent,
                tabs/* default.TwoThirdsTextAndProductsHorizontalTabsComponent */.Z.TwoThirdsTextAndProductsHorizontalTabsComponent,
                tabs/* default.ProductsHorizontalTimerTabsComponent */.Z.ProductsHorizontalTimerTabsComponent,
                tabs/* default.SideBySideParagraphAndProductsTabsComponent */.Z.SideBySideParagraphAndProductsTabsComponent,
                tabs/* default.TimelineTitledTabTabsComponent */.Z.TimelineTitledTabTabsComponent,
                tabs/* default.SideBySideTabsAndProcessTabsComponent */.Z.SideBySideTabsAndProcessTabsComponent,
                tabs/* default.SideBySideTabsAndTestimonialTabsComponent */.Z.SideBySideTabsAndTestimonialTabsComponent,
                tabs/* default.PersonasTabsComponent */.Z.PersonasTabsComponent,
                tabs/* default.SideBySideBoardViewsComponentTabsComponent */.Z.SideBySideBoardViewsComponentTabsComponent,
                tabs/* default.UseCasesTabsComponent */.Z.UseCasesTabsComponent,
                tabs/* default.MondayDemoTabsComponent */.Z.MondayDemoTabsComponent,
                tabs/* default.TimelineTabsComponent */.Z.TimelineTabsComponent,
                tabs/* default.ColoredTimerVerticalTabsComponent */.Z.ColoredTimerVerticalTabsComponent,
                tabs/* default.TimerVerticalTabsComponent */.Z.TimerVerticalTabsComponent,
                tabs/* default.RegularTabsComponent */.Z.RegularTabsComponent,
                tabs/* default.VerticalTabsComponent */.Z.VerticalTabsComponent,
                tabs/* default.BuildingBlocksTabsComponent */.Z.BuildingBlocksTabsComponent
            ]
        },
        {
            type: "REVIEWS",
            title: "Reviews",
            imgSrc: "/static/img/segments/icons/reviews.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_reviews
                reviews/* default.ParagraphAndCarouselReviewsComponent */.Z.ParagraphAndCarouselReviewsComponent,
                reviews/* default.RegularReviewsComponent */.Z.RegularReviewsComponent,
                reviews/* default.WithTitleReviewsComponent */.Z.WithTitleReviewsComponent,
                reviews/* default.ReviewCardsReviewsComponent */.Z.ReviewCardsReviewsComponent
            ]
        },
        {
            type: "TESTIMONIALS",
            title: "Testimonials",
            imgSrc: "/static/img/segments/icons/testimonials.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_testimonials
                testimonials/* default.CarouselTestimonialsComponent */.Z.CarouselTestimonialsComponent,
                testimonials/* default.PlainClassicTestimonialsComponent */.Z.PlainClassicTestimonialsComponent
            ]
        },
        {
            type: "LOGOS",
            title: "Logos",
            imgSrc: "/static/img/segments/icons/logos.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_logos
                logos/* default.LogosAndParagraphLogosComponent */.Z.LogosAndParagraphLogosComponent,
                logos/* default.AllLogosLogosComponent */.Z.AllLogosLogosComponent,
                logos/* default.TopLogosComponent */.Z.TopLogosComponent,
                logos/* default.BottomLogosComponent */.Z.BottomLogosComponent,
                logos/* default.ImagesLogosComponent */.Z.ImagesLogosComponent
            ]
        },
        {
            type: "SECURITY",
            title: "Security",
            imgSrc: "/static/img/segments/icons/security.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_security
                security/* default.LogosAndHeaderSecurityComponent */.Z.LogosAndHeaderSecurityComponent
            ]
        },
        {
            type: "INTEGRATIONS",
            title: "Integrations",
            imgSrc: "/static/img/segments/icons/integrations.png",
            divider: true,
            segmentLayouts: [
                // plop_marker:add_layout_config_integrations
                integrations/* default.MondayIntegrationsConnectionsComponent */.Z.MondayIntegrationsConnectionsComponent,
                integrations/* default.FloatingIntegrationsComponent */.Z.FloatingIntegrationsComponent
            ]
        },
        {
            type: "ENTERPRISE",
            title: "Enterprise",
            imgSrc: "/static/img/segments/icons/enterprise.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_enterprise
                enterprise/* default.ProofAndBadgesEnterpriseComponent */.Z.ProofAndBadgesEnterpriseComponent,
                enterprise/* default.SalesPhoneEnterpriseComponent */.Z.SalesPhoneEnterpriseComponent,
                enterprise/* default.AsymmetricEnterpriseComponent */.Z.AsymmetricEnterpriseComponent
            ]
        },
        {
            type: "FORM",
            title: "Form",
            imgSrc: "/static/img/segments/icons/form.png",
            divider: true,
            segmentLayouts: [
                // plop_marker:add_layout_config_form
                desktop_form/* default.HubspotOnDarkBackgroundFormComponent */.Z.HubspotOnDarkBackgroundFormComponent,
                desktop_form/* default.HubspotWithBulletsSideBySideFormComponent */.Z.HubspotWithBulletsSideBySideFormComponent,
                desktop_form/* default.HubspotAndLogosFormComponent */.Z.HubspotAndLogosFormComponent,
                desktop_form/* default.ZendeskSideBySideFormComponent */.Z.ZendeskSideBySideFormComponent,
                desktop_form/* default.ZendeskFormComponent */.Z.ZendeskFormComponent,
                desktop_form/* default.HubspotSideBySideFormComponent */.Z.HubspotSideBySideFormComponent
            ]
        },
        {
            type: "BLOG",
            title: "Blog",
            imgSrc: "/static/img/segments/icons/blog.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_blog
                blog/* default.RichTextBlogComponent */.Z.RichTextBlogComponent
            ]
        },
        {
            type: "IFRAME",
            title: "Iframe",
            imgSrc: "/static/img/segments/icons/iframe.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_iframe
                iframe/* default.HubspotDynamicFormIframeComponent */.Z.HubspotDynamicFormIframeComponent,
                iframe/* default.EmbeddedBoardIframeComponent */.Z.EmbeddedBoardIframeComponent,
                iframe/* default.SideBySideHubspotFormComponent */.Z.SideBySideHubspotFormComponent,
                iframe/* default.IframeDynamicWidthIframeComponent */.Z.IframeDynamicWidthIframeComponent
            ]
        },
        {
            type: "BANNER",
            title: "Banner",
            imgSrc: "/static/img/segments/icons/banner.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_banner
                banner/* default.PlainBannerComponent */.Z.PlainBannerComponent,
                banner/* default.WithBackgroundBannerComponent */.Z.WithBackgroundBannerComponent
            ]
        },
        {
            type: "PRICING",
            title: "Pricing",
            imgSrc: "/static/img/segments/icons/pricing.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_pricing
                pricing/* default.MultiProductsPricingComponent */.Z.MultiProductsPricingComponent,
                pricing/* default.FeaturesTablePricingComponent */.Z.FeaturesTablePricingComponent,
                pricing/* default.PricesAndFeaturesCardsPricingComponent */.Z.PricesAndFeaturesCardsPricingComponent,
                pricing/* default.FrequentlyAskedQuestionsPricingComponent */.Z.FrequentlyAskedQuestionsPricingComponent
            ]
        },
        {
            type: "EMBEDDED",
            title: "Embedded",
            imgSrc: "/static/img/segments/icons/embedded.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_embedded
                embedded/* default.WhatsNewItemsListEmbeddedComponent */.Z.WhatsNewItemsListEmbeddedComponent,
                embedded/* default.MarkdownEmbeddedComponent */.Z.MarkdownEmbeddedComponent
            ]
        },
        {
            type: "HOMEPAGE_FIRST_FOLD",
            title: "Homepage First Fold",
            imgSrc: "/static/img/segments/icons/homepage-first-fold.png",
            divider: true,
            segmentLayouts: [
                // plop_marker:add_layout_config_homepage-first-fold
                homepage_first_fold/* default.PlatformInteractiveExperienceHomepageFirstFoldComponent */.Z.PlatformInteractiveExperienceHomepageFirstFoldComponent,
                homepage_first_fold/* default.TagsByProductHomepageFirstFoldComponent */.Z.TagsByProductHomepageFirstFoldComponent,
                homepage_first_fold/* default.ProductsByUseCasesHomepageFirstFoldComponent */.Z.ProductsByUseCasesHomepageFirstFoldComponent,
                homepage_first_fold/* default.MondayProductsHomepageFirstFoldComponent */.Z.MondayProductsHomepageFirstFoldComponent,
                homepage_first_fold/* default.FullParagraphAndTagsHomepageFirstFoldComponent */.Z.FullParagraphAndTagsHomepageFirstFoldComponent,
                homepage_first_fold/* default.LiveBoardHomepageFirstFoldComponent */.Z.LiveBoardHomepageFirstFoldComponent,
                homepage_first_fold/* default.WelcomeBackHomepageFirstFoldComponent */.Z.WelcomeBackHomepageFirstFoldComponent,
                homepage_first_fold/* default.MondayUniverseHomepageFirstFoldComponent */.Z.MondayUniverseHomepageFirstFoldComponent,
                homepage_first_fold/* default.ScrollParallaxHomepageFirstFoldComponent */.Z.ScrollParallaxHomepageFirstFoldComponent,
                homepage_first_fold/* default.GlobeWithTopCtaHomepageFirstFoldComponent */.Z.GlobeWithTopCtaHomepageFirstFoldComponent,
                homepage_first_fold/* default.GlobeHomepageFirstFoldComponent */.Z.GlobeHomepageFirstFoldComponent,
                homepage_first_fold/* default.AnimatingBoardHomepageFirstFoldComponent */.Z.AnimatingBoardHomepageFirstFoldComponent
            ]
        },
        {
            type: "SHAPE",
            title: "Shapes (Beta)",
            imgSrc: "/static/img/segments/icons/shape.png",
            divider: true,
            segmentLayouts: [
                // plop_marker:add_layout_config_shape
                shape/* default.SquareShapeComponent */.Z.SquareShapeComponent,
                shape/* default.RectangleShapeComponent */.Z.RectangleShapeComponent,
                shape/* default.StarShapeComponent */.Z.StarShapeComponent,
                shape/* default.HotdogShapeComponent */.Z.HotdogShapeComponent,
                shape/* default.RingShapeComponent */.Z.RingShapeComponent
            ]
        },
        {
            type: "FOOTER",
            title: "Footer",
            imgSrc: "/static/img/segments/icons/footer.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_footer
                footer/* default.BaseFooterComponent */.Z.BaseFooterComponent
            ]
        },
        {
            type: "HEADER",
            title: "Header",
            imgSrc: "/static/img/segments/icons/header.png",
            segmentLayouts: [
                // plop_marker:add_layout_config_header
                header/* default.BaseHeaderComponent */.Z.BaseHeaderComponent
            ]
        }
    ],
    defaultData: desktop_dynamic_template_default_data_defaultData
};

;// CONCATENATED MODULE: ./components/templates-generator/config/mobile-dynamic-template/default-data.js

var mobile_dynamic_template_default_data_defaultData = {
    template: templates_names.TEMPLATE_NAMES.MobileDynamicTemplate,
    title: "",
    description: "",
    theme: "dark-theme",
    mobileTheme: "dark-theme",
    imagesLazyLoad: false,
    isMobile: true,
    segments: []
};

;// CONCATENATED MODULE: ./components/templates-generator/config/mobile-dynamic-template/mobile-dynamic-template-config.js

// plop_marker:segments_import
var MOBILE_DYNAMIC_TEMPLATE_CONFIG = {
    segments: [],
    defaultData: mobile_dynamic_template_default_data_defaultData
};

// EXTERNAL MODULE: ./segments/segments-config-service.js + 1 modules
var segments_config_service = __webpack_require__(69299);
;// CONCATENATED MODULE: ./components/templates-generator/config/developers-center-template/default-data.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var isMobile = false;
var segmentsConfig = (0,segments_config_service/* getSegmentsConfigs */.H)(isMobile);
var developers_center_template_default_data_defaultData = _object_spread_props(_object_spread({}, desktop_dynamic_template_default_data_defaultData), {
    baseLayoutStyleProps: {
        gridColumnStart: 2
    },
    templateClassName: "developers-center-template",
    template: templates_names.TEMPLATE_NAMES.DevelopersCenterTemplate,
    segments: [
        {
            type: segmentsConfig.DevelopersCenterHeaderComponent.type,
            props: _object_spread_props(_object_spread({}, segmentsConfig.DevelopersCenterHeaderComponent.component.defaultProps), {
                baseLayoutStyleProps: {
                    gridColumnStart: 1,
                    gridColumnEnd: 3
                }
            })
        },
        {
            type: segmentsConfig.DevelopersAppsMenuStaticComponent.type,
            props: _object_spread_props(_object_spread({}, segmentsConfig.DevelopersAppsMenuStaticComponent.component.defaultProps), {
                baseLayoutStyleProps: {
                    gridColumnStart: 1
                }
            })
        }
    ]
});

;// CONCATENATED MODULE: ./components/templates-generator/config/developers-center-template/developers-center-template-config.js
function developers_center_template_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function developers_center_template_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            developers_center_template_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function developers_center_template_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function developers_center_template_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        developers_center_template_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var DEVELOPERS_CENTER_TEMPLATE_CONFIG = developers_center_template_config_object_spread_props(developers_center_template_config_object_spread({}, DESKTOP_DYNAMIC_TEMPLATE_CONFIG), {
    defaultData: developers_center_template_default_data_defaultData
});

;// CONCATENATED MODULE: ./components/templates-generator/config/welcome-new-joiners-template/default-data.js
function default_data_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_data_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_data_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_data_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_data_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_data_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var default_data_isMobile = false;
var default_data_segmentsConfig = (0,segments_config_service/* getSegmentsConfigs */.H)(default_data_isMobile);
var welcome_new_joiners_template_default_data_defaultData = default_data_object_spread_props(default_data_object_spread({}, desktop_dynamic_template_default_data_defaultData), {
    template: templates_names.TEMPLATE_NAMES.WelcomeNewJoinersTemplate,
    segments: [
        {
            type: default_data_segmentsConfig.WelcomeNewJoinersHeaderComponent.type,
            props: default_data_segmentsConfig.WelcomeNewJoinersHeaderComponent.component.defaultProps
        },
        {
            type: default_data_segmentsConfig.WelcomeNewJoinersFooterComponent.type,
            props: default_data_segmentsConfig.WelcomeNewJoinersFooterComponent.component.defaultProps
        }
    ]
});

;// CONCATENATED MODULE: ./components/templates-generator/config/welcome-new-joiners-template/welcome-new-joiners-template-config.js
function welcome_new_joiners_template_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function welcome_new_joiners_template_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            welcome_new_joiners_template_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function welcome_new_joiners_template_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function welcome_new_joiners_template_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        welcome_new_joiners_template_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var WELCOME_NEW_JOINERS_TEMPLATE_CONFIG = welcome_new_joiners_template_config_object_spread_props(welcome_new_joiners_template_config_object_spread({}, DESKTOP_DYNAMIC_TEMPLATE_CONFIG), {
    defaultData: welcome_new_joiners_template_default_data_defaultData
});

;// CONCATENATED MODULE: ./components/templates-generator/config/remote-work-template/default-data.js
function remote_work_template_default_data_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function remote_work_template_default_data_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            remote_work_template_default_data_define_property(target, key, source[key]);
        });
    }
    return target;
}
function remote_work_template_default_data_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function remote_work_template_default_data_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        remote_work_template_default_data_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var remote_work_template_default_data_isMobile = false;
var remote_work_template_default_data_segmentsConfig = (0,segments_config_service/* getSegmentsConfigs */.H)(remote_work_template_default_data_isMobile);
var remote_work_template_default_data_defaultData = remote_work_template_default_data_object_spread_props(remote_work_template_default_data_object_spread({}, desktop_dynamic_template_default_data_defaultData), {
    template: templates_names.TEMPLATE_NAMES.RemoteWorkTemplate,
    segments: [
        {
            type: remote_work_template_default_data_segmentsConfig.RemoteWorkHeaderComponent.type,
            props: remote_work_template_default_data_segmentsConfig.RemoteWorkHeaderComponent.component.defaultProps
        },
        {
            type: remote_work_template_default_data_segmentsConfig.RemoteWorkFooterComponent.type,
            props: remote_work_template_default_data_segmentsConfig.RemoteWorkFooterComponent.component.defaultProps
        }
    ]
});

;// CONCATENATED MODULE: ./components/templates-generator/config/remote-work-template/remote-work-template-config.js
function remote_work_template_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function remote_work_template_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            remote_work_template_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function remote_work_template_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function remote_work_template_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        remote_work_template_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var REMOTE_WORK_TEMPLATE_CONFIG = remote_work_template_config_object_spread_props(remote_work_template_config_object_spread({}, DESKTOP_DYNAMIC_TEMPLATE_CONFIG), {
    defaultData: remote_work_template_default_data_defaultData
});

// EXTERNAL MODULE: ./constants/dynamic-asset-by-param.js
var dynamic_asset_by_param = __webpack_require__(93879);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
;// CONCATENATED MODULE: ./components/templates-generator/config/index.js
function config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






















var DESKTOP_DYNAMIC_TEMPLATE = {
    name: templates_names.TEMPLATE_NAMES.DynamicTemplate,
    label: "Dynamic Template [Desktop]"
};
var MOBILE_DYNAMIC_TEMPLATE = {
    name: templates_names.TEMPLATE_NAMES.MobileDynamicTemplate,
    label: "Dynamic Template [Mobile]"
};
var DEVELOPERS_CENTER_TEMPLATE = {
    name: templates_names.TEMPLATE_NAMES.DevelopersCenterTemplate,
    label: "Developers Center Template"
};
var WELCOME_NEW_JOINERS_TEMPLATE = {
    name: templates_names.TEMPLATE_NAMES.WelcomeNewJoinersTemplate,
    label: "Welcome New Joiners Template"
};
var REMOTE_WORK_TEMPLATE = {
    name: templates_names.TEMPLATE_NAMES.RemoteWorkTemplate,
    label: "Remote Work Template"
};
var TEMPLATE_TYPES = [
    DESKTOP_DYNAMIC_TEMPLATE,
    MOBILE_DYNAMIC_TEMPLATE,
    DEVELOPERS_CENTER_TEMPLATE,
    WELCOME_NEW_JOINERS_TEMPLATE,
    REMOTE_WORK_TEMPLATE,
    {
        name: templates_names.TEMPLATE_NAMES.LongTemplate,
        label: "Landing Page Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.SegmentsTemplate,
        label: "Multi Segment Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.FixedLongLpTemplate,
        label: "Fixed Long Landing Page"
    },
    {
        name: templates_names.TEMPLATE_NAMES.ArticleTemplate,
        label: "Article Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.DirectoryImagesTemplate,
        label: "Directory Images Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.MultipleDirectoryImagesTemplate,
        label: "Multiple Directories Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.OnePagerAssetTemplate,
        label: "One Pager Asset Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.OnePagerWithImageTemplate,
        label: "One Pager With Image Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.MobileOnePagerWithImageTemplate,
        label: "Mobile only One Pager With Image Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.OnePagerWithVideoTemplate,
        label: "One Pager With Video Template"
    },
    {
        name: templates_names.TEMPLATE_NAMES.CompetitorTemplate,
        label: "Competitor Template"
    }
];
var ADDABLE_TEMPLATE_TYPES = [
    DESKTOP_DYNAMIC_TEMPLATE,
    DEVELOPERS_CENTER_TEMPLATE,
    WELCOME_NEW_JOINERS_TEMPLATE
];
var TEMPLATE_CONFIGS = {
    LongTemplate: LONG_TEMPLATE_CONFIG,
    SegmentsTemplate: SEGMENTS_TEMPLATE_CONFIG,
    FixedLongLpTemplate: FIXED_LONG_LP_TEMPLATE_CONFIG,
    ArticleTemplate: ARTICLE_TEMPLATE_CONFIG,
    DirectoryImagesTemplate: DIRECTORY_IMAGES_TEMPLATE_CONFIG,
    MultipleDirectoryImagesTemplate: MULTIPLE_DIRECTORY_IMAGES_TEMPLATE_CONFIG,
    OnePagerAssetTemplate: ONE_PAGER_ASSET_TEMPLATE_CONFIG,
    OnePagerWithImageTemplate: ONE_PAGER_WITH_IMAGE_TEMPLATE_CONFIG,
    MobileOnePagerWithImageTemplate: MOBILE_ONE_PAGER_WITH_IMAGE_TEMPLATE_CONFIG,
    OnePagerWithVideoTemplate: ONE_PAGER_WITH_VIDEO_TEMPLATE_CONFIG,
    CompetitorTemplate: COMPETITOR_TEMPLATE_CONFIG,
    DynamicTemplate: DESKTOP_DYNAMIC_TEMPLATE_CONFIG,
    MobileDynamicTemplate: MOBILE_DYNAMIC_TEMPLATE_CONFIG,
    DevelopersCenterTemplate: DEVELOPERS_CENTER_TEMPLATE_CONFIG,
    WelcomeNewJoinersTemplate: WELCOME_NEW_JOINERS_TEMPLATE_CONFIG,
    RemoteWorkTemplate: REMOTE_WORK_TEMPLATE_CONFIG
};
var getTemplateBaseConfig = function(templateName) {
    var templateConfig = TEMPLATE_CONFIGS[templateName];
    var isMobile = templateConfig.defaultData.isMobile;
    return {
        template: {
            type: template_field_type.FIELD_TYPES.CONSTANT,
            label: "Template Type"
        },
        path: {
            type: template_field_type.FIELD_TYPES.HOMEPAGE_URL,
            label: "Page URL"
        },
        mobilePageUrl: {
            type: template_field_type.FIELD_TYPES.AUTOCOMPLETE,
            label: "Mobile Page Url",
            hide: isMobile,
            autocompleteType: (autocomplete_types_default()).PAGES
        },
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Topic Title"
        },
        description: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Topic Description"
        },
        clusterMiniSite: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Serve through Mini Site"
        },
        preloadFirstFoldImages: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Preload First Fold Images",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    src: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Source"
                    }
                }
            }
        },
        isTypeformDisabled: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable Typeform",
            systemConfig: true
        },
        perceptionSurveyTests: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Perception Survey Tests",
            labelDescription: "Add the test name exactly as it appears in BigBrain/Generator, without quote marks",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    testName: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Test name"
                    }
                }
            },
            systemConfig: true
        },
        useProductMiniSiteConfig: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use product Mini Site"
        },
        pageProductId: {
            type: template_field_type.FIELD_TYPES.PRODUCTS,
            label: "Connect to product signup"
        },
        clusterId: {
            type: template_field_type.FIELD_TYPES.CLUSTERS,
            label: "Cluster"
        },
        subClusterId: {
            type: template_field_type.FIELD_TYPES.SUB_CLUSTERS,
            label: "Use Case"
        },
        fetchClusterConfig: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Fetch User Cluster Config"
        },
        ignorePageClusterConfig: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Ignore clusterized page behaviour"
        },
        localeId: {
            type: template_field_type.FIELD_TYPES.LOCALES,
            label: "Locale"
        },
        overrideLanguages: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_TEXTS,
            label: "Override languages"
        },
        imagesLazyLoad: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Images Lazy Load (Deprecated!)"
        },
        lazyImages: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Images Lazy Load"
        },
        skipClustersQuestion: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Skip cluster question"
        },
        withFullstory: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "With FullStory"
        },
        fullstoryRecordingFrequency: {
            type: template_field_type.FIELD_TYPES.FULLSTORY_RECORDING_FREQUENCY,
            label: "FullStory Recording Frequency"
        },
        ogImagePath: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Facebook and Linkedin Sharable Image Preview (1200 X 628)"
        },
        twitterImagePath: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Twitter Sharable Image Preview (800 X 418)"
        },
        dynamicMetaTagImagesParamPath: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Use image from parameter",
            labelDescription: "Image (?".concat(query_params.DYNAMIC_ASSET_PARAM, "=xxxxx) from param build Cloudinary url under the selected path below, and will use it as meta-tags images."),
            options: dynamic_asset_by_param/* DYNAMIC_ASSET_PARAM_PATHS */.Y
        },
        dynamicMetaTagImageWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Width of dynamic shareable image"
        },
        dynamicMetaTagImageHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Height of dynamic shareable image"
        },
        canonicalUrl: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Canonical Url"
        },
        abTestName: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "AB Test Name"
        },
        abTestVariant: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "AB Test Variant"
        },
        marketingTemplateBoardIds: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Featured Board Template IDs (comma separated)"
        },
        showTrustpilotReviews: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show trustpilot reviews (Appears only with the footer)"
        },
        fontLazyLoad: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Load fonts after page displays"
        },
        aboveTheFoldSegmentsNumber: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Number of segments above the fold"
        },
        useExpandingSignup: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use expanding signup"
        },
        noIndex: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "No index (default false)"
        },
        noFollow: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "No follow (default false)"
        },
        disableGTM: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable GTM (DON'T TOUCH!)"
        },
        gtmContainerId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "GTM Container ID"
        },
        useSectionsMenu: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use sections Menu (Don't touch)"
        },
        enableHotjar: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Enable Hotjar",
            labelDescription: "Selecting a recording expiration date is required"
        },
        hotjarFinalDate: {
            type: template_field_type.FIELD_TYPES.CALENDAR,
            label: "Hotjar recording expiration date",
            calendarDaysRangeSize: 14
        },
        enablePageUsageDurationTracking: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Enable Page Usage Duration Tracking",
            labelDescription: "Via page_usage_duration event name and info1 as the time passed in the page"
        },
        pageBackgroundColorName: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Page background color"
        },
        is404Page: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is 404 page"
        },
        isPricingPage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is pricing page"
        },
        testTypeformContactSales: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Test Typeform contact sales (in released regions)"
        },
        forceTypeformContactSalesExperience: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Force Typeform contact sales experience (for Bizops QA)"
        },
        sendToSignupWithProductPage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Send to signup with product page"
        },
        addLiveBoardExperience: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Add live board experience"
        },
        embeddedBoardLink: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Embedded board link"
        },
        contactSalesTestMode: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Contact sales form test mode (don't use)"
        },
        forceProductSignup: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Force product signup (don't use)"
        },
        customHeadScript: {
            type: template_field_type.FIELD_TYPES.TEXT,
            textArea: true,
            rows: 4,
            label: "Custom head script"
        },
        customBodyScript: {
            type: template_field_type.FIELD_TYPES.TEXT,
            textArea: true,
            rows: 4,
            label: "Custom body script"
        },
        getMobileSoftSignup: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Get new mobile soft signup experience (in test - don't use)"
        },
        useNewTypeformUSVariant: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use new Typeform variant (in test - don't use)"
        },
        isV13PricingVersion: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show new pricing version V13"
        },
        isWMHighIntentExperience: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Get WM high intent experience (In test)"
        },
        withContactSalesStickyButton: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Contact Sales Sticky Button"
        },
        simulateStickyButtonTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Simulate Contact Sales Sticky Button test"
        },
        isInContactSalesNoHeaderTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is in contact sales no header test"
        },
        simulateContactSalesButtonInTheFooter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Simulate contact sales button in the footer"
        },
        simulateTalkToSalesInWebsiteHeaderTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Simulate talk to sales test in website header"
        },
        coupon: components/* coupon */.HK,
        extendTrialCookie: components/* extendTrialCookie */.V
    };
};
var getAdvancedTemplateBaseConfig = function() {
    return {
        exitPopupConfig: components/* exitPopupConfig */.RX
    };
};
var getConfigWithoutSegments = function(templateName) {
    var specificTemplateConfig = TEMPLATE_CONFIGS[templateName];
    var segments = specificTemplateConfig.segments, restTemplateConfig = _object_without_properties(specificTemplateConfig, [
        "segments"
    ]);
    return restTemplateConfig;
};
var getTemplateConfig = function(templateName) {
    var baseConfig = getTemplateBaseConfig(templateName);
    var advancedBaseConfig = getAdvancedTemplateBaseConfig();
    var specificConfig = getConfigWithoutSegments(templateName);
    return config_object_spread({}, baseConfig, specificConfig, advancedBaseConfig);
};
var getSegmentsConfig = function(templateName) {
    var specificTemplateConfig = TEMPLATE_CONFIGS[templateName];
    var segments = specificTemplateConfig.segments;
    return segments ? {
        segments: segments
    } : {};
};
var getTemplateConfigWithoutBase = function(templateName) {
    // create a copy so we won't change the original
    var specificConfig = getConfigWithoutSegments(templateName);
    return config_object_spread({}, specificConfig);
};
var getSegmentsDynamicsFetchMapper = function(templateName) {
    var _templateConfig_segments;
    var templateConfig = TEMPLATE_CONFIGS[templateName];
    return (_templateConfig_segments = templateConfig.segments) === null || _templateConfig_segments === void 0 ? void 0 : _templateConfig_segments.reduce(function(acc, segment) {
        segment.segmentLayouts.forEach(function(item) {
            if (item) {
                var type = item.type, dynamicsFetch = item.dynamicsFetch;
                if (dynamicsFetch) {
                    acc[type] = dynamicsFetch;
                }
            }
        });
        return acc;
    }, {});
};


/***/ }),

/***/ 48023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Multiple Reviews",
    fields: {
        columnWidth: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Column Width"
        },
        reviews: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Reviews",
            nestedConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                fields: {
                    reviewContent: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_TEXTS,
                        label: "Review Content"
                    },
                    reviewerName: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Reviewer Name"
                    },
                    reviewedOn: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Reviewed On",
                        options: [
                            "Capterra",
                            "G2 Crowd",
                            "Trustpilot"
                        ]
                    }
                }
            }
        }
    }
});


/***/ }),

/***/ 56903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Short Footer",
    fields: {}
});


/***/ }),

/***/ 18019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_templates_generator_config_segments_reviews_reviews_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48023);


/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Social Proof",
    fields: {
        Signup: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Signup",
            fields: {
                buttonColor: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    label: "Signup Button Color",
                    possibleColors: [
                        "brand-blue",
                        "brand-pink",
                        "brand-iris",
                        "brand-green",
                        "brand-red",
                        "brand-purple"
                    ]
                }
            }
        },
        Reviews: components_templates_generator_config_segments_reviews_reviews_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    }
});


/***/ }),

/***/ 25421:
/***/ (function(module) {


var PAGES = "pages";
module.exports = {
    PAGES: PAGES
};


/***/ }),

/***/ 69299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ getSegmentsConfigs; }
});

// EXTERNAL MODULE: ./segments/desktop/index.js + 19 modules
var desktop = __webpack_require__(29107);
;// CONCATENATED MODULE: ./segments/mobile/index.js
// plop_marker:segments_import
/* harmony default export */ var mobile = ({});

;// CONCATENATED MODULE: ./segments/segments-config-service.js


var getSegmentsConfigs = function(isMobile) {
    return isMobile ? mobile : desktop/* default */.Z;
};


/***/ })

}]);